import React, { useState, useEffect, useCallback } from 'react';
import {
  adminGetCities, adminCreateCity, adminUpdateCity, adminDeleteCity,
  adminGetExcursions, adminCreateExcursion, adminUpdateExcursion, adminDeleteExcursion,
  adminGetSteps, adminCreateStep, adminUpdateStep, adminDeleteStep,
  adminGetPromoCodes, adminGeneratePromoCodes, adminDeletePromoCodes, adminUploadFile,
  adminGetDiscountCodes, adminCreateDiscountCode, adminDeleteDiscountCode,
  adminGetUsers, adminGetUserDetail, adminDeleteUserAnswers, adminGetExcursionPlayers, adminDeleteUserExcursion, adminDeleteUser, adminExportUsers,
  adminGetLanguages, adminCreateLanguage, adminUpdateLanguage, adminDeleteLanguage, adminResolveMapLink
} from '../../api';
import { useLanguages, useLangEditor, LangBar } from './langEditor';
import { TOPICS } from '../../topics';
import { jsPDF } from 'jspdf';
import QRCode from 'qrcode';
import './AdminPage.css';

const API_URL = process.env.REACT_APP_API_URL || 'http://localhost:4000/api';
const BASE_URL = API_URL.replace('/api', '');

const TABS = [
  { id: 'cities', label: 'Города' },
  { id: 'excursions', label: 'Экскурсии' },
  { id: 'steps', label: 'Шаги' },
  { id: 'promo', label: 'Промокоды' },
  { id: 'discounts', label: 'Скидки' },
  { id: 'users', label: 'Пользователи' },
  { id: 'languages', label: 'Языки' },
];

export default function AdminPage() {
  const [tab, setTab] = useState('cities');
  return (
    <div className="admin-root" dir="ltr">
      <div className="admin-header">
        <h1 className="admin-header-title" style={{display: 'flex', alignItems: 'center', gap: 10}}><img src="/logo-icon.png" alt="" style={{width: 36, height: 36, borderRadius: 9}} />Voice of Dubai · Админ-панель</h1>
        <a href="/" className="admin-back-link">← На сайт</a>
      </div>
      <div className="admin-tabs">
        {TABS.map(t => (
          <button key={t.id} className={`admin-tab ${tab === t.id ? 'active' : ''}`} onClick={() => setTab(t.id)}>{t.label}</button>
        ))}
      </div>
      <div className="admin-content">
        {tab === 'cities' && <CitiesTab />}
        {tab === 'excursions' && <ExcursionsTab />}
        {tab === 'steps' && <StepsTab />}
        {tab === 'promo' && <PromoTab />}
        {tab === 'discounts' && <DiscountsTab />}
        {tab === 'users' && <UsersTab />}
        {tab === 'languages' && <LanguagesTab />}
      </div>
    </div>
  );
}

function FileUpload({ label, currentUrl, onUploaded }) {
  const [uploading, setUploading] = useState(false);
  async function handleFile(e) {
    const file = e.target.files[0];
    if (!file) return;
    setUploading(true);
    try { const data = await adminUploadFile(file); onUploaded(data.url); } catch (err) { alert('Ошибка: ' + err.message); }
    setUploading(false);
  }
  return (
    <div className="admin-field">
      <label className="admin-label">{label}</label>
      {currentUrl && (
        <div className="admin-preview">
          {currentUrl.match(/\.(mp3|wav|ogg|m4a)$/i) ? <audio src={BASE_URL + currentUrl} controls style={{ width: '100%' }} />
           : currentUrl.match(/\.(mp4|webm)$/i) ? <video src={BASE_URL + currentUrl} controls style={{ width: '100%', maxHeight: 120 }} />
           : <img src={BASE_URL + currentUrl} alt="" style={{ maxWidth: '100%', maxHeight: 80, borderRadius: 8 }} />}
        </div>
      )}
      <input type="file" onChange={handleFile} disabled={uploading} />
      {uploading && <span className="admin-uploading">Загрузка...</span>}
    </div>
  );
}

// ===== CITIES =====
function slugify(str) {
  const map = {'а':'a','б':'b','в':'v','г':'g','д':'d','е':'e','ё':'e','ж':'zh','з':'z','и':'i','й':'y','к':'k','л':'l','м':'m','н':'n','о':'o','п':'p','р':'r','с':'s','т':'t','у':'u','ф':'f','х':'h','ц':'ts','ч':'ch','ш':'sh','щ':'sch','ъ':'','ы':'y','ь':'','э':'e','ю':'yu','я':'ya'};
  return (str || '').toLowerCase().split('').map(c => map[c] !== undefined ? map[c] : c).join('').replace(/[^a-z0-9]+/g, '-').replace(/^-+|-+$/g, '');
}

function cityFormFrom(city) {
  return { name: city.name || '', description: city.description || '', image_url: city.image_url || '', slug: city.slug || slugify(city.name || ''), is_hidden: city.is_hidden || false, sort_order: city.sort_order || 0 };
}

function CitiesTab() {
  const [cities, setCities] = useState([]);
  const [editing, setEditing] = useState(null);
  const [form, setForm] = useState(cityFormFrom({}));
  const { languages, defLang } = useLanguages();
  const [cityTr, setCityTr] = useState({});
  const langEd = useLangEditor({ defLang, sharedKeys: ['slug', 'is_hidden', 'sort_order'], capture: () => form, restore: setForm, toData: f => ({ ...f, slug: f.slug || slugify(f.name) }), fromData: cityFormFrom });
  const load = useCallback(async () => { try { setCities(await adminGetCities()); } catch (e) { console.error(e); } }, []);
  useEffect(() => { load(); }, [load]);

  function startEdit(city) { setEditing(city.id); setForm(cityFormFrom(city)); langEd.reset(city.translations); setCityTr(city.translations || {}); }
  function startNew() { setEditing('new'); setForm(cityFormFrom({})); langEd.reset({}); setCityTr({}); }
  async function save() {
    const { base, translations } = langEd.collect();
    const payload = { ...base, translations };
    try { if (editing === 'new') await adminCreateCity(payload); else await adminUpdateCity(editing, payload); setEditing(null); load(); } catch (e) { alert(e.message); }
  }
  async function remove(id) { if (!window.confirm('Удалить город?')) return; try { await adminDeleteCity(id); load(); } catch (e) { alert(e.message); } }

  return (<div>
    <div className="admin-section-header"><h2>Города</h2><button className="admin-btn primary" onClick={startNew}>+ Добавить</button></div>
    {editing && (<div className="admin-form-card">
      <h3>{editing === 'new' ? 'Новый город' : 'Редактировать'}</h3>
      <LangBar languages={languages} lang={langEd.lang} onSwitch={langEd.switchTo} translations={cityTr} />
      <div className="admin-field"><label className="admin-label">Название</label><input className="admin-input" value={form.name} onChange={e => setForm({...form, name: e.target.value, slug: form.slug || slugify(e.target.value)})} /></div>
      <div className="admin-field"><label className="admin-label">URL-имя (slug)</label><input className="admin-input" value={form.slug} onChange={e => setForm({...form, slug: e.target.value.toLowerCase().replace(/[^a-z0-9-]/g, '')})} placeholder="sochi" />
      <div style={{fontSize: 11, color: '#aaa', marginTop: 4}}>Будет использовано в адресе: dubaivoice.sl-people.com/{form.slug || 'gorod'}</div></div>
      <div className="admin-field"><label className="admin-label">Описание</label><textarea className="admin-textarea" value={form.description} onChange={e => setForm({...form, description: e.target.value})} /></div>
      <FileUpload label="Картинка" currentUrl={form.image_url} onUploaded={url => setForm(prev => ({...prev, image_url: url}))} />
      <div className="admin-field" style={{background: '#fff8e1', padding: 10, borderRadius: 8}}>
        <label className="admin-label"><input type="checkbox" checked={form.is_hidden} onChange={e => setForm({...form, is_hidden: e.target.checked})} /> <b>Скрытый город</b> (только по прямой ссылке)</label>
        <div style={{fontSize: 11, color: '#888', marginTop: 4}}>Город не показывается в каталоге, и ни одна экскурсия из него не попадает в общий список. Доступен только тем, у кого есть прямая ссылка вида dubaivoice.sl-people.com/{form.slug || 'gorod'} или ссылка на конкретную экскурсию. Удобно скрыть город целиком вместо того, чтобы метить каждую экскурсию.</div>
      </div>
      <div className="admin-form-actions"><button className="admin-btn primary" onClick={save}>Сохранить</button><button className="admin-btn" onClick={() => setEditing(null)}>Отмена</button></div>
    </div>)}
    <div className="admin-list">
      {cities.map(c => (<div key={c.id} className="admin-list-item">
        {c.image_url && <img src={BASE_URL + c.image_url} alt="" className="admin-list-thumb" />}
        <div className="admin-list-info"><strong>{c.name} {c.is_hidden && <span style={{fontSize: 11, color: '#fff', background: '#f5a623', padding: '2px 6px', borderRadius: 4, fontWeight: 'normal'}}>СКРЫТЫЙ</span>}</strong><span className="admin-list-sub">{c.description}</span></div>
        <div className="admin-list-actions"><button className="admin-btn small" onClick={() => startEdit(c)}>Ред.</button><button className="admin-btn small danger" onClick={() => remove(c.id)}>Уд.</button></div>
      </div>))}
      {cities.length === 0 && <p className="admin-empty">Нет городов</p>}
    </div>
  </div>);
}

// ===== EXCURSIONS =====
const EXC_SHARED_KEYS = ['city_id', 'is_free', 'price', 'paywall_after_step', 'is_hidden', 'has_points', 'partner_url', 'finish_hide_review', 'duration_min', 'sort_order', 'is_kids', 'in_builder'];
function excFormFrom(exc) {
  return { city_id: exc.city_id || '', title: exc.title || '', description: exc.description || '', image_url: exc.image_url || '', is_free: exc.is_free !== undefined ? !!exc.is_free : true, price: exc.price || 0, paywall_after_step: exc.paywall_after_step || 2, sort_order: exc.sort_order || 0, is_hidden: exc.is_hidden || false, has_points: exc.has_points || false, final_image_url: exc.final_image_url || '', partner_logo: exc.partner_logo || '', partner_url: exc.partner_url || '', partner_label: exc.partner_label || '', exit_confirm_label: exc.exit_confirm_label || '', finish_title: exc.finish_title || '', finish_subtitle: exc.finish_subtitle || '', finish_hide_review: exc.finish_hide_review || false, subtitle: exc.subtitle || '', district: exc.district || '', duration_min: exc.duration_min || 0, gallery: Array.isArray(exc.gallery) ? exc.gallery : [], is_kids: !!exc.is_kids, in_builder: !!exc.in_builder };
}
function excToData(form) {
  return { ...form, price: parseInt(form.price) || 0, paywall_after_step: parseInt(form.paywall_after_step) || 2, duration_min: parseInt(form.duration_min) || 0 };
}
function ExcursionsTab() {
  const [excursions, setExcursions] = useState([]);
  const [cities, setCities] = useState([]);
  const [editing, setEditing] = useState(null);
  const [form, setForm] = useState(excFormFrom({}));
  const { languages, defLang } = useLanguages();
  const [excTr, setExcTr] = useState({});
  const langEd = useLangEditor({ defLang, sharedKeys: EXC_SHARED_KEYS, capture: () => form, restore: setForm, toData: excToData, fromData: excFormFrom });
  const load = useCallback(async () => { try { setExcursions(await adminGetExcursions()); setCities(await adminGetCities()); } catch (e) { console.error(e); } }, []);
  useEffect(() => { load(); }, [load]);

  function startNew() { setEditing('new'); setForm(excFormFrom({ city_id: cities[0]?.id || '' })); langEd.reset({}); setExcTr({}); }
  function startEdit(exc) { setEditing(exc.id); setForm(excFormFrom(exc)); langEd.reset(exc.translations); setExcTr(exc.translations || {}); }

  async function downloadQR(exc) {
    const url = `${window.location.origin}/excursion/${exc.id}`;
    try {
      const dataUrl = await QRCode.toDataURL(url, { width: 600, margin: 2 });
      const a = document.createElement('a');
      a.href = dataUrl;
      a.download = `qr-${exc.title.replace(/[^a-zа-я0-9]/gi, '_')}.png`;
      a.click();
    } catch (e) { alert('Ошибка QR: ' + e.message); }
  }
  function copyLink(exc) {
    const url = `${window.location.origin}/excursion/${exc.id}`;
    navigator.clipboard.writeText(url).then(() => alert('Ссылка скопирована:\n' + url)).catch(() => prompt('Скопируйте ссылку:', url));
  }
  async function save() {
    try { const { base, translations } = langEd.collect(); const data = { ...base, translations };
    if (editing === 'new') await adminCreateExcursion(data); else await adminUpdateExcursion(editing, data); setEditing(null); load(); } catch (e) { alert(e.message); }
  }
  async function remove(id) { if (!window.confirm('Удалить экскурсию?')) return; try { await adminDeleteExcursion(id); load(); } catch (e) { alert(e.message); } }

  return (<div>
    <div className="admin-section-header"><h2>Экскурсии</h2><button className="admin-btn primary" onClick={startNew}>+ Добавить</button></div>
    {editing && (<div className="admin-form-card">
      <h3>{editing === 'new' ? 'Новая экскурсия' : 'Редактировать'}</h3>
      <LangBar languages={languages} lang={langEd.lang} onSwitch={langEd.switchTo} translations={excTr} />
      <div className="admin-field"><label className="admin-label">Город</label>
        <select className="admin-input" value={form.city_id} onChange={e => setForm({...form, city_id: parseInt(e.target.value)})}>
          <option value="">Выберите</option>{cities.map(c => <option key={c.id} value={c.id}>{c.name}</option>)}
        </select></div>
      <div className="admin-field"><label className="admin-label">Название</label><input className="admin-input" dir="auto" value={form.title} onChange={e => setForm({...form, title: e.target.value})} /></div>
      <div className="admin-field"><label className="admin-label">Подзаголовок (золотые буквы под названием, например «Al Seef | Al Fahidi»)</label><input className="admin-input" dir="auto" value={form.subtitle} onChange={e => setForm({...form, subtitle: e.target.value})} /></div>
      <div className="admin-row">
        <div className="admin-field" style={{flex: 1}}><label className="admin-label">Район (с булавкой, например «Old Dubai»)</label><input className="admin-input" dir="auto" value={form.district} onChange={e => setForm({...form, district: e.target.value})} /></div>
        <div className="admin-field" style={{flex: '0 0 150px'}}><label className="admin-label">Длительность, мин</label><input className="admin-input" type="number" value={form.duration_min} onChange={e => setForm({...form, duration_min: e.target.value})} /></div>
      </div>
      <div className="admin-field"><label className="admin-label">Описание</label><textarea className="admin-textarea" dir="auto" value={form.description} onChange={e => setForm({...form, description: e.target.value})} /></div>
      <FileUpload label="Главная картинка (сверху на экране экскурсии и в списке)" currentUrl={form.image_url} onUploaded={url => setForm(prev => ({...prev, image_url: url}))} />
      <div className="admin-field" style={{background: '#f5f8fb', padding: 10, borderRadius: 8}}>
        <label className="admin-label" style={{fontWeight: 700}}>Галерея (маленькие фото под описанием)</label>
        <div style={{display: 'flex', gap: 8, flexWrap: 'wrap', marginBottom: 8}}>
          {(form.gallery || []).map((g, i) => (
            <div key={i} style={{position: 'relative'}}>
              <img src={BASE_URL + g} alt="" style={{width: 90, height: 64, objectFit: 'cover', borderRadius: 8}} />
              <button type="button" className="admin-btn small danger" style={{position: 'absolute', top: 2, right: 2, padding: '0 6px'}} onClick={() => setForm(prev => ({...prev, gallery: prev.gallery.filter((_, k) => k !== i)}))}>×</button>
            </div>
          ))}
        </div>
        <FileUpload label="Добавить фото в галерею" currentUrl="" onUploaded={url => setForm(prev => ({...prev, gallery: [...(prev.gallery || []), url]}))} />
      </div>
      <div className="admin-field"><label className="admin-label"><input type="checkbox" checked={form.is_free} onChange={e => setForm({...form, is_free: e.target.checked})} /> Бесплатная</label></div>
      {!form.is_free && (<>
        <div className="admin-field"><label className="admin-label">Цена (руб.)</label><input className="admin-input" type="number" value={form.price} onChange={e => setForm({...form, price: e.target.value})} /></div>
        <div className="admin-field"><label className="admin-label">Paywall после шага №</label><input className="admin-input" type="number" value={form.paywall_after_step} onChange={e => setForm({...form, paywall_after_step: e.target.value})} /></div>
      </>)}
      <div className="admin-field" style={{background: '#fff8e1', padding: 10, borderRadius: 8}}>
        <label className="admin-label"><input type="checkbox" checked={form.is_hidden} onChange={e => setForm({...form, is_hidden: e.target.checked})} /> <b>Скрытая</b> (только по прямой ссылке / QR)</label>
        <div style={{fontSize: 11, color: '#888', marginTop: 4}}>Не показывается в каталоге и на главной. Доступна только тем, у кого есть ссылка. Для демо-показов клиентам.</div>
      </div>
      <div className="admin-field" style={{background: '#f3f0ff', padding: 10, borderRadius: 8}}>
        <label className="admin-label" style={{fontWeight: 700}}>🧭 «Соберите свою прогулку»</label>
        <label className="admin-label"><input type="checkbox" checked={!!form.in_builder} onChange={e => setForm({...form, in_builder: e.target.checked})} /> <b>Брать точки этой экскурсии</b> для персональных прогулок</label>
        <div style={{fontSize: 11, color: '#888', marginTop: 2, marginBottom: 8}}>Отметьте самую полную экскурсию района (где есть все точки). Короткие версии отмечать не нужно — одинаковые точки система всё равно посчитает один раз. Турист отвечает на вопросы «сколько времени / что интересно / с кем», и из этих точек собирается его маршрут: главные точки всегда, дополнительные — по интересам и времени.</div>
        <label className="admin-label"><input type="checkbox" checked={!!form.is_kids} onChange={e => setForm({...form, is_kids: e.target.checked})} /> <b>Детская квест-версия</b> (маскот, детские задания)</label>
        <div style={{fontSize: 11, color: '#888', marginTop: 2}}>Если турист с ребёнком выберет «Игровой квест», прогулка соберётся из детских экскурсий с этой отметкой.</div>
      </div>
      <div className="admin-field" style={{background: '#e8f5e9', padding: 10, borderRadius: 8}}>
        <label className="admin-label"><input type="checkbox" checked={form.has_points} onChange={e => setForm({...form, has_points: e.target.checked})} /> <b>Квест с баллами</b></label>
        <div style={{fontSize: 11, color: '#888', marginTop: 4}}>За правильные ответы — баллы, за подсказки — штраф. В конце экран с результатом. Баллы настраиваются у каждого шага с вопросом.</div>
        {form.has_points && (
          <div style={{marginTop: 8}}>
            <FileUpload label="Картинка для финального экрана (вертикальная, на весь экран)" currentUrl={form.final_image_url} onUploaded={url => setForm(prev => ({...prev, final_image_url: url}))} />
          </div>
        )}
      </div>
      <div className="admin-field">
        <FileUpload label="Логотип партнёра (отель/курорт) — необязательно" currentUrl={form.partner_logo} onUploaded={url => setForm(prev => ({...prev, partner_logo: url}))} />
        <div style={{fontSize: 11, color: '#888', marginTop: 4}}>Показывается на странице экскурсии и на финальном экране. Лучше PNG с прозрачным фоном.</div>
        <label className="admin-label" style={{marginTop: 10}}>Ссылка на сайт партнёра (необязательно)</label>
        <input className="admin-input" placeholder="например: hotel-example.ru" value={form.partner_url}
          onChange={e => setForm({...form, partner_url: e.target.value})} />
        <div style={{fontSize: 11, color: '#888', marginTop: 4}}>Если указать — по нажатию на логотип откроется этот сайт в новой вкладке.</div>

        <label className="admin-label" style={{marginTop: 10}}>Подпись над логотипом (необязательно)</label>
        <input className="admin-input" placeholder="напр. «Экскурсия от партнёра», «Квест от партнёра», «Подарок от...»"
          value={form.partner_label}
          onChange={e => setForm({...form, partner_label: e.target.value})} />
        <div style={{fontSize: 11, color: '#888', marginTop: 4}}>Текст над логотипом партнёра на странице экскурсии. Если оставить пустым — никакая подпись не показывается, будет только логотип.</div>

        <label className="admin-label" style={{marginTop: 10}}>Название для окна перехода на сайт партнёра (необязательно)</label>
        <input className="admin-input" placeholder="напр. «Квест по Розе Хутор», «Дольмены Красной поляны»"
          value={form.exit_confirm_label || ''}
          onChange={e => setForm({...form, exit_confirm_label: e.target.value})} />
        <div style={{fontSize: 11, color: '#888', marginTop: 4}}>Когда гость нажмёт на логотип партнёра, покажется окно «Вы покидаете «…» и перейдёте на сайт партнёра». Что писать в кавычках — задаётся здесь. Если пусто — по умолчанию «Voice of Dubai».</div>
      </div>
      <div className="admin-field" style={{background: '#eef4ff', padding: 10, borderRadius: 8}}>
        <label className="admin-label" style={{fontWeight: 700}}>🏁 Финальный экран</label>
        <div style={{fontSize: 11, color: '#888', marginBottom: 8}}>Что покажется, когда гость закончит. Если оставите пусто — будет стандартный текст «Поздравляем! Вы прошли квест».</div>

        <label className="admin-label" style={{marginTop: 6}}>Заголовок финального экрана (необязательно)</label>
        <input className="admin-input" placeholder="напр. «Поздравляем!», «Спасибо!», «Прогулка завершена»"
          value={form.finish_title || ''}
          onChange={e => setForm({...form, finish_title: e.target.value})} />
        <div style={{fontSize: 11, color: '#aaa', marginTop: 4}}>По умолчанию: «Поздравляем!»</div>

        <label className="admin-label" style={{marginTop: 10}}>Подпись под заголовком (необязательно)</label>
        <textarea className="admin-textarea" rows={2}
          placeholder="напр. «Вы прошли квест», «Спасибо за прогулку по Красной Поляне», «Аудио-променад завершён»"
          value={form.finish_subtitle || ''}
          onChange={e => setForm({...form, finish_subtitle: e.target.value})} />
        <div style={{fontSize: 11, color: '#aaa', marginTop: 4}}>По умолчанию: «Вы прошли квест»</div>

        <label className="admin-label" style={{marginTop: 10}}>
          <input type="checkbox" checked={!!form.finish_hide_review}
            onChange={e => setForm({...form, finish_hide_review: e.target.checked})} />
          {' '}Скрыть кнопку «⭐ Оценить экскурсию»
        </label>
        <div style={{fontSize: 11, color: '#888', marginTop: 4}}>Полезно, если отель или площадка не хотят собирать оценки. Баллы и кнопки «На главную» / «Мои экскурсии» останутся.</div>
      </div>
      <div className="admin-form-actions"><button className="admin-btn primary" onClick={save}>Сохранить</button><button className="admin-btn" onClick={() => setEditing(null)}>Отмена</button></div>
    </div>)}
    <div className="admin-list">
      {excursions.map(exc => (<div key={exc.id} className="admin-list-item">
        {exc.image_url && <img src={BASE_URL + exc.image_url} alt="" className="admin-list-thumb" />}
        <div className="admin-list-info">
          <strong>{exc.title} {exc.is_hidden && <span style={{fontSize: 11, color: '#fff', background: '#f5a623', padding: '2px 6px', borderRadius: 4, fontWeight: 'normal'}}>СКРЫТАЯ</span>}</strong>
          <span className="admin-list-sub">{exc.city_name} · {exc.is_free ? 'Бесплатная' : `${exc.price}`} · {exc.total_steps} шагов</span>
        </div>
        <div className="admin-list-actions">
          <button className="admin-btn small" onClick={() => copyLink(exc)} title="Скопировать ссылку">🔗</button>
          <button className="admin-btn small" onClick={() => downloadQR(exc)} title="Скачать QR-код">QR</button>
          <button className="admin-btn small" onClick={() => startEdit(exc)}>Ред.</button>
          <button className="admin-btn small danger" onClick={() => remove(exc.id)}>Уд.</button>
        </div>
      </div>))}
      {excursions.length === 0 && <p className="admin-empty">Нет экскурсий</p>}
    </div>
  </div>);
}

// ===== MAP POINT (Google Maps) =====
function AdminMapPicker({ lat, lng, onSelect }) {
  const [link, setLink] = React.useState('');
  const [busy, setBusy] = React.useState(false);
  const [msg, setMsg] = React.useState('');
  const has = lat && lng && !isNaN(parseFloat(lat)) && !isNaN(parseFloat(lng));
  async function fromLink() {
    if (!link.trim()) return;
    setBusy(true); setMsg('');
    try { const c = await adminResolveMapLink(link.trim()); onSelect(c.lat.toFixed(6), c.lng.toFixed(6)); setLink(''); setMsg('Точка поставлена ✓'); }
    catch (e) { setMsg(e.message); }
    setBusy(false);
  }
  return (
    <div>
      <div style={{display: 'flex', gap: 8, marginBottom: 6}}>
        <input className="admin-input" style={{flex: 1}} placeholder="Вставьте ссылку из Google Карт или координаты: 25.2636, 55.2997"
          value={link} onChange={e => setLink(e.target.value)} onKeyDown={e => e.key === 'Enter' && (e.preventDefault(), fromLink())} />
        <button type="button" className="admin-btn primary" onClick={fromLink} disabled={busy}>{busy ? '…' : 'Поставить точку'}</button>
      </div>
      <div style={{fontSize: 11, color: '#888', marginBottom: 8, lineHeight: 1.45}}>
        Как получить: откройте Google Карты → найдите место → нажмите на точку → «Поделиться» → «Копировать ссылку».
        Или на компьютере нажмите правой кнопкой по месту на карте и щёлкните по цифрам вверху меню — координаты скопируются.
        {msg && <b style={{display: 'block', color: msg.includes('✓') ? '#2E8B57' : '#C0392B', marginTop: 4}}>{msg}</b>}
      </div>
      {has && (
        <iframe title="map" src={`https://maps.google.com/maps?q=${parseFloat(lat)},${parseFloat(lng)}&z=17&output=embed`}
          style={{width: '100%', height: 250, border: 0, borderRadius: 10, display: 'block', marginBottom: 6}} loading="lazy" />
      )}
      {has && <a href={`https://www.google.com/maps?q=${parseFloat(lat)},${parseFloat(lng)}`} target="_blank" rel="noreferrer" style={{fontSize: 12}}>Открыть эту точку в Google Картах ↗</a>}
    </div>
  );
}

// ===== STEPS =====
const STEP_SHARED_KEYS = ['step_number', 'question_type', 'has_question', 'has_fun_fact', 'has_video', 'lat', 'lng', 'points', 'hint_penalty', 'max_attempts', 'is_required', 'allow_reveal', 'is_key', 'duration_min', 'topics', 'allow_skip'];

// Sums the length of the step's audio files to suggest "minutes per step"
function useAudioMinutes(audios) {
  const [sec, setSec] = useState(0);
  const key = (audios || []).map(a => a && a.url).filter(Boolean).join('|');
  useEffect(() => {
    let alive = true;
    const urls = key ? key.split('|') : [];
    if (!urls.length) { setSec(0); return; }
    Promise.all(urls.map(u => new Promise(res => {
      const a = new Audio(); a.preload = 'metadata';
      a.onloadedmetadata = () => res(isFinite(a.duration) ? a.duration : 0);
      a.onerror = () => res(0);
      a.src = BASE_URL + u;
    }))).then(list => { if (alive) setSec(list.reduce((x, y) => x + y, 0)); });
    return () => { alive = false; };
  }, [key]);
  return sec;
}

function StepBuilderFields({ form, setForm }) {
  const audioSec = useAudioMinutes(form.audios);
  const suggested = Math.max(1, Math.ceil(audioSec / 60) + (form.has_question ? 2 : 0) + 1);
  const topics = form.topics || [];
  const toggleTopic = (k) => setForm(prev => ({ ...prev, topics: (prev.topics || []).includes(k) ? prev.topics.filter(x => x !== k) : [...(prev.topics || []), k] }));
  return (
    <div className="admin-field" style={{ background: '#f3f0ff', padding: 10, borderRadius: 8 }}>
      <label className="admin-label" style={{ fontWeight: 700 }}>🧭 Для «Соберите свою прогулку»</label>
      <label className="admin-label"><input type="checkbox" checked={!!form.is_key} onChange={e => setForm({ ...form, is_key: e.target.checked })} /> <b>Главная точка</b> — без неё прогулка теряет смысл (вступление, финал, «визитная карточка» района)</label>
      <div className="admin-row" style={{ alignItems: 'flex-end', marginTop: 6 }}>
        <div className="admin-field" style={{ flex: '0 0 150px', marginBottom: 0 }}>
          <label className="admin-label">Минут на шаг</label>
          <input className="admin-input" type="number" min="0" value={form.duration_min || ''} placeholder={String(suggested)} onChange={e => setForm({ ...form, duration_min: e.target.value })} />
        </div>
        <div style={{ fontSize: 12, color: '#666', paddingBottom: 10 }}>
          {audioSec > 0 ? <>Аудио: {Math.round(audioSec / 60 * 10) / 10} мин. Предлагаю <b>{suggested}</b> мин </> : <>Если не заполнить — посчитаю сам ≈ {suggested} мин </>}
          {!form.duration_min && <button type="button" className="admin-btn small" onClick={() => setForm(prev => ({ ...prev, duration_min: suggested }))}>Поставить {suggested}</button>}
        </div>
      </div>
      <label className="admin-label" style={{ marginTop: 8 }}>Темы (по ним подбираются точки под интересы туриста)</label>
      <div style={{ display: 'flex', flexWrap: 'wrap', gap: 6 }}>
        {TOPICS.map(t => (
          <button type="button" key={t.key} onClick={() => toggleTopic(t.key)}
            className={`admin-lang-tab ${topics.includes(t.key) ? 'active' : ''}`}>{t.ru}</button>
        ))}
      </div>
    </div>
  );
}

// Builds the step editor state from a DB-shaped step object
function buildStepForm(step) {
    // Migrate legacy single audio_url into audios list if needed
    const audios = (Array.isArray(step.audios) && step.audios.length > 0)
      ? step.audios
      : (step.audio_url ? [{ url: step.audio_url, title: '' }] : []);
    const swipe_cards = (Array.isArray(step.swipe_cards) && step.swipe_cards.length > 0)
      ? step.swipe_cards
      : (step.question_type === 'swipe' && step.question
          ? [{ text: step.question, answer: (step.answers && step.answers[0]) || 'верю', image: '' }]
          : []);
    const puzzle = (step.puzzle && typeof step.puzzle === 'object' && !Array.isArray(step.puzzle))
      ? { image: step.puzzle.image || '', size: step.puzzle.size || 3 }
      : { image: '', size: 3 };
    const sd = (step.sort_data && typeof step.sort_data === 'object' && !Array.isArray(step.sort_data))
      ? { categories: Array.isArray(step.sort_data.categories) ? step.sort_data.categories : [], items: Array.isArray(step.sort_data.items) ? step.sort_data.items : [] }
      : { categories: [], items: [] };
    const dd = (step.dish_data && typeof step.dish_data === 'object' && !Array.isArray(step.dish_data))
      ? { container_title: step.dish_data.container_title || '', items: Array.isArray(step.dish_data.items) ? step.dish_data.items : [] }
      : { container_title: '', items: [] };
    const order_items = Array.isArray(step.order_items) ? step.order_items : [];
    const beforeafter = (step.beforeafter && typeof step.beforeafter === 'object' && !Array.isArray(step.beforeafter))
      ? { before: step.beforeafter.before || '', after: step.beforeafter.after || '', before_label: step.beforeafter.before_label || '', after_label: step.beforeafter.after_label || '' }
      : { before: '', after: '', before_label: '', after_label: '' };
    const scratch = (step.scratch && typeof step.scratch === 'object' && !Array.isArray(step.scratch))
      ? { image: step.scratch.image || '', cover_label: step.scratch.cover_label || '', caption: step.scratch.caption || '' }
      : { image: '', cover_label: '', caption: '' };
    const memseq = (step.memseq && typeof step.memseq === 'object' && !Array.isArray(step.memseq))
      ? { length: step.memseq.length || 4, reveal_image: step.memseq.reveal_image || '', reveal_text: step.memseq.reveal_text || '' }
      : { length: 4, reveal_image: '', reveal_text: '' };
    const ice = (step.ice && typeof step.ice === 'object' && !Array.isArray(step.ice))
      ? { image: step.ice.image || '', caption: step.ice.caption || '', taps: step.ice.taps || 15 }
      : { image: '', caption: '', taps: 15 };
    const pairs_data = (step.pairs_data && typeof step.pairs_data === 'object' && !Array.isArray(step.pairs_data) && Array.isArray(step.pairs_data.pairs))
      ? { pairs: step.pairs_data.pairs, back_image: step.pairs_data.back_image || '' }
      : { pairs: [], back_image: '' };
    const postcard_data = (step.postcard_data && typeof step.postcard_data === 'object' && !Array.isArray(step.postcard_data))
      ? { backgrounds: Array.isArray(step.postcard_data.backgrounds) ? step.postcard_data.backgrounds : [], stickers: Array.isArray(step.postcard_data.stickers) ? step.postcard_data.stickers : [] }
      : { backgrounds: [], stickers: [] };
    const phrase_data = (step.phrase_data && typeof step.phrase_data === 'object' && !Array.isArray(step.phrase_data))
      ? { cards: Array.isArray(step.phrase_data.cards) ? step.phrase_data.cards : [], extras: Array.isArray(step.phrase_data.extras) ? step.phrase_data.extras : [] }
      : { cards: [], extras: [] };
    const form = { step_number: step.step_number, title: step.title || '', audio_url: step.audio_url || '', audios, image_url: step.image_url || '', text: step.text || '', has_question: step.has_question, question_type: step.question_type || 'text', question: step.question || '', answers: step.answers || [], answer_options: step.answer_options || [], swipe_cards, puzzle, sort_data: sd, dish_data: dd, order_items, max_attempts: step.max_attempts || 0, beforeafter, scratch, memseq, ice, pairs_data, postcard_data, phrase_data, hint: step.hint || '', has_fun_fact: step.has_fun_fact, fun_fact_images: step.fun_fact_images || [], fun_fact_text: step.fun_fact_text || '', has_video: step.has_video, video_url: step.video_url || '', lat: step.lat || '', lng: step.lng || '', map_image_url: step.map_image_url || '', points: step.points || 0, hint_penalty: step.hint_penalty || 0, reveal_image: step.reveal_image || '', reveal_text: step.reveal_text || '', is_required: step.is_required || false, allow_reveal: step.allow_reveal || false, location_label: step.location_label || '', is_key: !!step.is_key, allow_skip: !!step.allow_skip, duration_min: step.duration_min || 0, topics: Array.isArray(step.topics) ? step.topics : [] };
    return { form, answersText: (step.answers || []).join(', '), optionsText: (step.answer_options || []).join('\n') };
}

// Turns the step editor state into the data object sent to the server
function normalizeStep(form, answersText, optionsText) {
      const audios = (form.audios || []).filter(a => a && a.url).map(a => ({ url: a.url, title: a.title || '' }));
      const data = {
        ...form,
        step_number: parseInt(form.step_number),
        answers: answersText.split(',').map(a => a.trim().toLowerCase()).filter(Boolean),
        audios,
        audio_url: audios[0]?.url || '', // keep legacy field in sync (offline/back-compat)
        answer_options: form.question_type === 'choice'
          ? optionsText.split('\n').map(o => o.trim()).filter(Boolean)
          : [],
        swipe_cards: form.question_type === 'swipe'
          ? (form.swipe_cards || [])
              .filter(c => c && (c.text || '').trim())
              .map(c => ({ text: c.text.trim(), answer: c.answer === 'не верю' ? 'не верю' : 'верю', image: c.image || '' }))
          : [],
        puzzle: form.question_type === 'puzzle'
          ? { image: (form.puzzle && form.puzzle.image) || '', size: parseInt(form.puzzle && form.puzzle.size) || 3 }
          : {},
        sort_data: form.question_type === 'sort'
          ? {
              categories: (form.sort_data.categories || []).map(c => (c || '').trim()).filter(Boolean),
              items: (form.sort_data.items || [])
                .filter(it => it && ((it.text || '').trim() || it.image))
                .map(it => ({ text: (it.text || '').trim(), image: it.image || '', cat: parseInt(it.cat) || 0 })),
            }
          : {},
        dish_data: form.question_type === 'dish'
          ? {
              container_title: (form.dish_data.container_title || '').trim(),
              items: (form.dish_data.items || [])
                .filter(it => it && ((it.text || '').trim() || it.image))
                .map(it => ({ text: (it.text || '').trim(), image: it.image || '', correct: !!it.correct })),
            }
          : {},
        order_items: form.question_type === 'order'
          ? (form.order_items || [])
              .filter(it => it && ((it.text || '').trim() || it.image))
              .map(it => ({ text: (it.text || '').trim(), image: it.image || '' }))
          : [],
        max_attempts: parseInt(form.max_attempts) || 0,
        beforeafter: form.question_type === 'beforeafter'
          ? {
              before: (form.beforeafter && form.beforeafter.before) || '',
              after: (form.beforeafter && form.beforeafter.after) || '',
              before_label: (form.beforeafter && form.beforeafter.before_label) || '',
              after_label: (form.beforeafter && form.beforeafter.after_label) || '',
            }
          : {},
        scratch: form.question_type === 'scratch'
          ? {
              image: (form.scratch && form.scratch.image) || '',
              cover_label: (form.scratch && form.scratch.cover_label) || '',
              caption: (form.scratch && form.scratch.caption) || '',
            }
          : {},
        memseq: form.question_type === 'memseq'
          ? {
              length: Math.max(2, Math.min(8, parseInt(form.memseq && form.memseq.length) || 4)),
              reveal_image: (form.memseq && form.memseq.reveal_image) || '',
              reveal_text: (form.memseq && form.memseq.reveal_text) || '',
            }
          : {},
        ice: form.question_type === 'ice'
          ? {
              image: (form.ice && form.ice.image) || '',
              caption: (form.ice && form.ice.caption) || '',
              taps: Math.max(5, Math.min(60, parseInt(form.ice && form.ice.taps) || 15)),
            }
          : {},
        pairs_data: form.question_type === 'pairs'
          ? {
              back_image: (form.pairs_data && form.pairs_data.back_image) || '',
              pairs: ((form.pairs_data && form.pairs_data.pairs) || [])
                .map(p => ({
                  a: { text: (p.a && p.a.text || '').trim(), image: (p.a && p.a.image) || '' },
                  b: { text: (p.b && p.b.text || '').trim(), image: (p.b && p.b.image) || '' },
                }))
                .filter(p => (p.a.text || p.a.image) && (p.b.text || p.b.image)),
            }
          : {},
        postcard_data: form.question_type === 'postcard'
          ? {
              backgrounds: ((form.postcard_data && form.postcard_data.backgrounds) || []).filter(Boolean),
              stickers: ((form.postcard_data && form.postcard_data.stickers) || []).filter(Boolean),
            }
          : {},
        phrase_data: form.question_type === 'phrase'
          ? {
              cards: ((form.phrase_data && form.phrase_data.cards) || [])
                .filter(it => it && ((it.text || '').trim() || it.image))
                .map(it => ({ text: (it.text || '').trim(), image: it.image || '' })),
              extras: ((form.phrase_data && form.phrase_data.extras) || [])
                .filter(it => it && ((it.text || '').trim() || it.image))
                .map(it => ({ text: (it.text || '').trim(), image: it.image || '' })),
            }
          : {},
      };
  return data;
}

function StepsTab() {
  const [excursions, setExcursions] = useState([]);
  const [selectedExc, setSelectedExc] = useState(null);
  const [steps, setSteps] = useState([]);
  const [editing, setEditing] = useState(null);
  const [form, setForm] = useState({ step_number: 1, title: '', audio_url: '', audios: [], image_url: '', text: '', has_question: false, question_type: 'text', question: '', answers: [], answer_options: [], swipe_cards: [], puzzle: { image: '', size: 3 }, sort_data: { categories: [], items: [] }, dish_data: { container_title: '', items: [] }, order_items: [], max_attempts: 0, beforeafter: { before: '', after: '', before_label: '', after_label: '' }, scratch: { image: '', cover_label: '', caption: '' }, memseq: { length: 4, reveal_image: '', reveal_text: '' }, ice: { image: '', caption: '', taps: 15 }, pairs_data: { pairs: [], back_image: '' }, postcard_data: { backgrounds: [], stickers: [] }, hint: '', has_fun_fact: false, fun_fact_images: [], fun_fact_text: '', has_video: false, video_url: '', lat: '', lng: '', map_image_url: '', points: 0, hint_penalty: 0 });
  const [answersText, setAnswersText] = useState('');
  const [optionsText, setOptionsText] = useState('');
  // Copy steps from another excursion
  const [importing, setImporting] = useState(false);
  const [importSrc, setImportSrc] = useState('');
  const [importSrcSteps, setImportSrcSteps] = useState([]);
  const [importChecked, setImportChecked] = useState({});
  const [importBusy, setImportBusy] = useState(false);
  const { languages, defLang } = useLanguages();
  const [stepTr, setStepTr] = useState({});
  const langEd = useLangEditor({
    defLang, sharedKeys: STEP_SHARED_KEYS,
    capture: () => ({ form, answersText, optionsText }),
    restore: st => { setForm(st.form); setAnswersText(st.answersText); setOptionsText(st.optionsText); },
    toData: st => normalizeStep(st.form, st.answersText, st.optionsText),
    fromData: d => buildStepForm(d),
  });
  const loadExcursions = useCallback(async () => { try { setExcursions(await adminGetExcursions()); } catch (e) { console.error(e); } }, []);
  useEffect(() => { loadExcursions(); }, [loadExcursions]);

  async function loadSteps(excId) { setSelectedExc(excId); try { setSteps(await adminGetSteps(excId)); } catch (e) { console.error(e); } }
  function startNew() {
    setEditing('new');
    const nextNum = steps.length > 0 ? Math.max(...steps.map(s => s.step_number)) + 1 : 1;
    setForm({ step_number: nextNum, title: '', audio_url: '', audios: [], image_url: '', text: '', has_question: false, question_type: 'text', question: '', answers: [], answer_options: [], swipe_cards: [], puzzle: { image: '', size: 3 }, sort_data: { categories: [], items: [] }, dish_data: { container_title: '', items: [] }, order_items: [], max_attempts: 0, beforeafter: { before: '', after: '', before_label: '', after_label: '' }, scratch: { image: '', cover_label: '', caption: '' }, memseq: { length: 4, reveal_image: '', reveal_text: '' }, ice: { image: '', caption: '', taps: 15 }, pairs_data: { pairs: [], back_image: '' }, postcard_data: { backgrounds: [], stickers: [] }, phrase_data: { cards: [], extras: [] }, hint: '', has_fun_fact: false, fun_fact_images: [], fun_fact_text: '', has_video: false, video_url: '', lat: '', lng: '', map_image_url: '', points: 0, hint_penalty: 0, reveal_image: '', reveal_text: '', is_required: false, allow_reveal: false, location_label: '', is_key: false, allow_skip: false, duration_min: 0, topics: [] });
    setAnswersText('');
    setOptionsText('');
    langEd.reset({});
    setStepTr({});
  }
  function startEdit(step) {
    setEditing(step.id);
    const st = buildStepForm(step);
    setForm(st.form);
    setAnswersText(st.answersText);
    setOptionsText(st.optionsText);
    langEd.reset(step.translations);
    setStepTr(step.translations || {});
  }
  async function save() {
    try {
      const { base, translations } = langEd.collect();
      const data = { ...base, translations };
      if (editing === 'new') await adminCreateStep(selectedExc, data); else await adminUpdateStep(editing, data);
      setEditing(null); loadSteps(selectedExc);
    } catch (e) { alert(e.message); }
  }
  async function remove(id) { if (!window.confirm('Удалить шаг?')) return; try { await adminDeleteStep(id); loadSteps(selectedExc); } catch (e) { alert(e.message); } }
  function addFunFactImage(url) { setForm(prev => ({...prev, fun_fact_images: [...prev.fun_fact_images, url]})); }
  function removeFunFactImage(idx) { setForm(prev => ({...prev, fun_fact_images: prev.fun_fact_images.filter((_, i) => i !== idx)})); }

  function startImport() {
    setImporting(true); setImportSrc(''); setImportSrcSteps([]); setImportChecked({});
  }
  async function loadImportSteps(srcId) {
    setImportSrc(srcId); setImportChecked({});
    try { setImportSrcSteps(await adminGetSteps(srcId)); } catch (e) { alert(e.message); }
  }
  function buildStepCopy(s, newNum) {
    return {
      step_number: newNum,
      title: s.title || '',
      audio_url: s.audio_url || '',
      audios: Array.isArray(s.audios) ? s.audios : [],
      image_url: s.image_url || '',
      text: s.text || '',
      has_question: s.has_question || false,
      question_type: s.question_type || 'text',
      question: s.question || '',
      answers: s.answers || [],
      answer_options: s.answer_options || [],
      swipe_cards: Array.isArray(s.swipe_cards) ? s.swipe_cards : [],
      puzzle: (s.puzzle && typeof s.puzzle === 'object' && !Array.isArray(s.puzzle)) ? s.puzzle : {},
      sort_data: (s.sort_data && typeof s.sort_data === 'object' && !Array.isArray(s.sort_data)) ? s.sort_data : {},
      dish_data: (s.dish_data && typeof s.dish_data === 'object' && !Array.isArray(s.dish_data)) ? s.dish_data : {},
      order_items: Array.isArray(s.order_items) ? s.order_items : [],
      beforeafter: (s.beforeafter && typeof s.beforeafter === 'object' && !Array.isArray(s.beforeafter)) ? s.beforeafter : {},
      scratch: (s.scratch && typeof s.scratch === 'object' && !Array.isArray(s.scratch)) ? s.scratch : {},
      memseq: (s.memseq && typeof s.memseq === 'object' && !Array.isArray(s.memseq)) ? s.memseq : {},
      ice: (s.ice && typeof s.ice === 'object' && !Array.isArray(s.ice)) ? s.ice : {},
      pairs_data: (s.pairs_data && typeof s.pairs_data === 'object' && !Array.isArray(s.pairs_data)) ? s.pairs_data : {},
      postcard_data: (s.postcard_data && typeof s.postcard_data === 'object' && !Array.isArray(s.postcard_data)) ? s.postcard_data : {},
      phrase_data: (s.phrase_data && typeof s.phrase_data === 'object' && !Array.isArray(s.phrase_data)) ? s.phrase_data : {},
      reveal_image: s.reveal_image || '',
      reveal_text: s.reveal_text || '',
      is_required: s.is_required || false,
      allow_skip: s.allow_skip || false,
      allow_reveal: s.allow_reveal || false,
      max_attempts: s.max_attempts || 0,
      hint: s.hint || '',
      has_fun_fact: s.has_fun_fact || false,
      fun_fact_images: s.fun_fact_images || [],
      fun_fact_text: s.fun_fact_text || '',
      has_video: s.has_video || false,
      video_url: s.video_url || '',
      lat: s.lat || '',
      lng: s.lng || '',
      map_image_url: s.map_image_url || '',
      points: s.points || 0,
      hint_penalty: s.hint_penalty || 0,
      location_label: s.location_label || '',
      translations: s.translations || {},
    };
  }
  async function doImport() {
    const chosen = importSrcSteps.filter(s => importChecked[s.id]);
    if (chosen.length === 0) return alert('Отметьте галочками шаги для копирования');
    setImportBusy(true);
    try {
      let nextNum = steps.length > 0 ? Math.max(...steps.map(s => s.step_number)) + 1 : 1;
      for (const s of chosen.sort((a, b) => a.step_number - b.step_number)) {
        await adminCreateStep(selectedExc, buildStepCopy(s, nextNum));
        nextNum++;
      }
      setImporting(false);
      loadSteps(selectedExc);
      alert(`Скопировано шагов: ${chosen.length}`);
    } catch (e) { alert(e.message); }
    setImportBusy(false);
  }

  return (<div>
    <div className="admin-section-header"><h2>Шаги экскурсии</h2></div>
    <div className="admin-field"><label className="admin-label">Выберите экскурсию</label>
      <select className="admin-input" value={selectedExc || ''} onChange={e => loadSteps(parseInt(e.target.value))}>
        <option value="">-- Выберите --</option>{excursions.map(exc => <option key={exc.id} value={exc.id}>{exc.title} ({exc.city_name})</option>)}
      </select></div>
    {selectedExc && (<>
      <div style={{display: 'flex', gap: 8, flexWrap: 'wrap', marginBottom: 16}}>
        <button className="admin-btn primary" onClick={startNew}>+ Добавить шаг</button>
        <button className="admin-btn" onClick={startImport}>📋 Скопировать шаги из другой экскурсии</button>
      </div>
      {importing && (<div className="admin-form-card">
        <h3>Скопировать шаги</h3>
        <div className="admin-field"><label className="admin-label">Из какой экскурсии копировать</label>
          <select className="admin-input" value={importSrc} onChange={e => loadImportSteps(parseInt(e.target.value))}>
            <option value="">-- Выберите экскурсию --</option>
            {excursions.filter(exc => exc.id !== selectedExc).map(exc => <option key={exc.id} value={exc.id}>{exc.title} ({exc.city_name})</option>)}
          </select>
        </div>
        {importSrc && (
          <div style={{fontSize: 12, color: '#888', marginBottom: 8}}>Отметьте шаги, которые нужно скопировать. Они добавятся в конец текущей экскурсии (со всем содержимым: аудио, фото, вопросы, викторины).</div>
        )}
        {importSrc && importSrcSteps.length === 0 && <p className="admin-empty">В этой экскурсии нет шагов</p>}
        {importSrcSteps.length > 0 && (
          <div className="admin-list" style={{marginBottom: 12}}>
            {importSrcSteps.map(s => (
              <label key={s.id} className="admin-list-item" style={{cursor: 'pointer', alignItems: 'center'}}>
                <input type="checkbox" style={{width: 18, height: 18, flexShrink: 0}}
                  checked={!!importChecked[s.id]}
                  onChange={() => setImportChecked(p => ({...p, [s.id]: !p[s.id]}))} />
                <div className="admin-step-num">{s.step_number}</div>
                {s.image_url && <img src={BASE_URL + s.image_url} alt="" className="admin-list-thumb" />}
                <div className="admin-list-info"><strong>{s.title || `Шаг ${s.step_number}`}</strong>
                  <span className="admin-list-sub">{s.has_question && '❓ '}{s.has_fun_fact && '💡 '}{s.has_video && '🎬 '}{(Array.isArray(s.audios) && s.audios.length > 0) || s.audio_url ? '🎧' : ''}</span></div>
              </label>
            ))}
          </div>
        )}
        <div className="admin-form-actions">
          <button className="admin-btn primary" onClick={doImport} disabled={importBusy}>
            {importBusy ? 'Копирую...' : `Скопировать выбранные (${Object.values(importChecked).filter(Boolean).length})`}
          </button>
          <button className="admin-btn" onClick={() => setImporting(false)} disabled={importBusy}>Отмена</button>
        </div>
      </div>)}
      {editing && (<div className="admin-form-card">
        <h3>{editing === 'new' ? 'Новый шаг' : 'Редактировать шаг'}</h3>
        <LangBar languages={languages} lang={langEd.lang} onSwitch={langEd.switchTo} translations={stepTr} />
        <div className="admin-row">
          <div className="admin-field" style={{flex: '0 0 80px'}}><label className="admin-label">№</label><input className="admin-input" type="number" value={form.step_number} onChange={e => setForm({...form, step_number: e.target.value})} /></div>
          <div className="admin-field" style={{flex: 1}}><label className="admin-label">Название</label><input className="admin-input" dir="auto" value={form.title} onChange={e => setForm({...form, title: e.target.value})} /></div>
        </div>
        <div className="admin-field"><label className="admin-label">Место (подпись с булавкой, например «Old Dubai») — необязательно</label><input className="admin-input" dir="auto" value={form.location_label || ''} onChange={e => setForm({...form, location_label: e.target.value})} /></div>
        <FileUpload label="Картинка" currentUrl={form.image_url} onUploaded={url => setForm(prev => ({...prev, image_url: url}))} />
        <div className="admin-field" style={{background: '#f5f8fb', padding: 10, borderRadius: 8}}>
          <label className="admin-label" style={{fontWeight: 700}}>Аудио (можно несколько)</label>
          {(form.audios || []).map((a, i) => (
            <div key={i} style={{borderTop: i > 0 ? '1px solid #e0e0e0' : 'none', paddingTop: i > 0 ? 10 : 0, marginTop: i > 0 ? 10 : 0}}>
              <input className="admin-input" style={{marginBottom: 6}} placeholder="Название аудио (необязательно)"
                value={a.title || ''}
                onChange={e => { const arr = [...form.audios]; arr[i] = { ...arr[i], title: e.target.value }; setForm({...form, audios: arr}); }} />
              <FileUpload label={`Файл аудио #${i + 1}`} currentUrl={a.url} onUploaded={url => setForm(prev => { const arr = [...prev.audios]; arr[i] = { ...arr[i], url }; return {...prev, audios: arr}; })} />
              <button type="button" className="admin-btn small danger" onClick={() => setForm({...form, audios: form.audios.filter((_, idx) => idx !== i)})}>Удалить аудио</button>
            </div>
          ))}
          <button type="button" className="admin-btn small" style={{marginTop: 8}}
            onClick={() => setForm({...form, audios: [...(form.audios || []), { url: '', title: '' }]})}>+ Добавить аудио</button>
        </div>
        <div className="admin-field"><label className="admin-label">Текст</label>
          <div className="editor-toolbar">
            <button type="button" className="editor-btn" title="Жирный" onClick={() => { const ta = document.getElementById('step-text-editor'); const s = ta.selectionStart; const e = ta.selectionEnd; const txt = form.text; const sel = txt.substring(s, e); setForm({...form, text: txt.substring(0, s) + '**' + (sel || 'текст') + '**' + txt.substring(e)}); }}>B</button>
            <button type="button" className="editor-btn" style={{fontStyle:'italic'}} title="Курсив" onClick={() => { const ta = document.getElementById('step-text-editor'); const s = ta.selectionStart; const e = ta.selectionEnd; const txt = form.text; const sel = txt.substring(s, e); setForm({...form, text: txt.substring(0, s) + '*' + (sel || 'текст') + '*' + txt.substring(e)}); }}>I</button>
            <button type="button" className="editor-btn" title="Вставить ссылку" onClick={() => { const ta = document.getElementById('step-text-editor'); const s = ta.selectionStart; const e = ta.selectionEnd; const txt = form.text; const sel = txt.substring(s, e); const url = window.prompt('Введите ссылку (с https://)', 'https://'); if (!url || url === 'https://') return; setForm({...form, text: txt.substring(0, s) + '[' + (sel || 'текст ссылки') + '](' + url + ')' + txt.substring(e)}); }}>🔗</button>
            <span className="editor-sep">|</span>
            <select className="editor-select" onChange={(e) => { if (!e.target.value) return; const tag = e.target.value; const ta = document.getElementById('step-text-editor'); const s = ta.selectionStart; const end = ta.selectionEnd; const txt = form.text; const sel = txt.substring(s, end); setForm({...form, text: txt.substring(0, s) + `[size:${tag}]` + (sel || 'текст') + `[/size]` + txt.substring(end)}); e.target.value = ''; }}>
              <option value="">Размер</option>
              <option value="12">Мелкий (12)</option>
              <option value="14">Обычный (14)</option>
              <option value="16">Средний (16)</option>
              <option value="18">Крупный (18)</option>
              <option value="22">Большой (22)</option>
            </select>
            <select className="editor-select" onChange={(e) => { if (!e.target.value) return; const align = e.target.value; const ta = document.getElementById('step-text-editor'); const s = ta.selectionStart; const end = ta.selectionEnd; const txt = form.text; const sel = txt.substring(s, end); setForm({...form, text: txt.substring(0, s) + `[align:${align}]` + (sel || 'текст') + `[/align]` + txt.substring(end)}); e.target.value = ''; }}>
              <option value="">Выравнивание</option>
              <option value="left">Слева</option>
              <option value="center">По центру</option>
              <option value="right">Справа</option>
            </select>
          </div>
          <textarea id="step-text-editor" className="admin-textarea" rows={4} value={form.text} onChange={e => setForm({...form, text: e.target.value})} placeholder="Текст шага..." />
          <div style={{fontSize: 11, color: '#aaa', marginTop: 4}}>**жирный**, *курсив*, [текст](https://...) — ссылка, [size:18]размер[/size], [align:center]центр[/align]. Простые URL вида https://... сами становятся кликабельными.</div></div>
        <div className="admin-field"><label className="admin-label"><input type="checkbox" checked={form.has_question} onChange={e => setForm({...form, has_question: e.target.checked})} /> <b>Есть задание</b> (вопрос, викторина, пазл, сортировка, игры — тип выбирается ниже)</label></div>
        {form.has_question && (<>
          <div className="admin-field"><label className="admin-label">Тип ответа</label>
            <select className="admin-input" value={form.question_type} onChange={e => setForm({...form, question_type: e.target.value})}>
              <option value="text">Текстовый ответ (ввод с клавиатуры)</option>
              <option value="choice">Выбор варианта (кнопки)</option>
              <option value="swipe">Викторина «Верю / Не верю» (карточки)</option>
              <option value="puzzle">Пазл (собрать картинку)</option>
              <option value="sort">Сортировка (разложить по категориям)</option>
              <option value="dish">Собери набор (блюдо, чемодан, номер…)</option>
              <option value="order">Расставить по порядку</option>
              <option value="beforeafter">«Тогда / Сейчас» (шторка по фото)</option>
              <option value="scratch">Скретч-сюрприз (стереть и открыть)</option>
              <option value="memseq">Повтори цвета (игра на память)</option>
              <option value="ice">Разбей лёд (тапать по экрану)</option>
              <option value="pairs">Соедини пары (карточки на память)</option>
              <option value="postcard">Конструктор открытки</option>
              <option value="phrase">Составь фразу (перетащить карточки в рамку)</option>
            </select>
          </div>

          <div className="admin-field" style={{background: '#eef7ee', padding: 10, borderRadius: 8}}>
            <label className="admin-label"><input type="checkbox" checked={!!form.allow_skip} disabled={!!form.is_required}
              onChange={e => setForm({...form, allow_skip: e.target.checked})} /> <b>Можно пропустить</b> — у игрока будет кнопка «Пропустить»</label>
            <div style={{fontSize: 11, color: '#888', marginTop: 4}}>Для необязательных заданий: например, не хочет человек собирать пазл — нажимает «Пропустить» и идёт дальше без баллов. {form.is_required && <b style={{color: '#c0392b'}}>Недоступно, пока стоит «Обязательное задание».</b>}</div>
          </div>

          {form.question_type !== 'text' && form.question_type !== 'choice' && form.question_type !== 'swipe' && (
            <div className="admin-field">
              <label className="admin-label">Заголовок задания (необязательно)</label>
              <input className="admin-input" dir="auto" value={form.question || ''} placeholder="напр. «Match the word with its meaning», «Соберите картинку»"
                onChange={e => setForm({...form, question: e.target.value})} />
              <div style={{fontSize: 11, color: '#aaa', marginTop: 4}}>Крупная строка над заданием у игрока. Если пусто — над заданием будет только подсказка, как играть.</div>
            </div>
          )}

          {(form.question_type === 'text' || form.question_type === 'choice' || form.question_type === 'order' || form.question_type === 'sort' || form.question_type === 'dish' || form.question_type === 'memseq' || form.question_type === 'phrase') && (<>
            <div className="admin-field" style={{background: '#fde8e8', padding: 10, borderRadius: 8}}>
              <label className="admin-label"><input type="checkbox" checked={!!form.is_required}
                onChange={e => setForm({...form, is_required: e.target.checked})} /> <b>Обязательное задание</b> — нельзя пропустить без верного ответа</label>
              <div style={{fontSize: 11, color: '#888', marginTop: 4}}>Игрок не сможет перейти к следующему шагу, пока не ответит правильно. Кнопка «Дальше» не появится, попытки не ограничены (поле ниже игнорируется).</div>
            </div>
            <div className="admin-field"><label className="admin-label">Количество попыток (0 — без ограничения){form.is_required && <span style={{fontSize: 11, color: '#c0392b', marginLeft: 6}}>игнорируется, если «Обязательное»</span>}</label>
              <input className="admin-input" type="number" min={0} value={form.max_attempts}
                onChange={e => setForm({...form, max_attempts: e.target.value})} placeholder="0" disabled={!!form.is_required} />
              <div style={{fontSize: 11, color: '#aaa', marginTop: 4}}>После неверного ответа игроку показывается, сколько попыток осталось. Когда попытки закончатся — можно идти дальше (баллы не начислятся). За попытки баллы не снимаются.</div>
            </div>
          </>)}

          {form.question_type === 'postcard' ? (<>
            <div className="admin-field" style={{background: '#f5f8fb', padding: 10, borderRadius: 8}}>
              <label className="admin-label" style={{fontWeight: 700}}>Фоны открытки</label>
              <div style={{fontSize: 11, color: '#888', marginBottom: 8}}>Загрузите несколько фонов (турист выберет один). Горизонтальные, ~1200×800. Можно добавить логотип/рамку клиента прямо в фон.</div>
              <div style={{display: 'flex', flexWrap: 'wrap', gap: 8, marginBottom: 8}}>
                {((form.postcard_data && form.postcard_data.backgrounds) || []).map((u, i) => (
                  <div key={i} style={{position: 'relative'}}>
                    <img src={BASE_URL + u} alt="" style={{width: 80, height: 56, objectFit: 'cover', borderRadius: 6, border: '1px solid #ddd'}} />
                    <button type="button" className="admin-btn small danger" style={{position: 'absolute', top: -8, right: -8, padding: '0 6px'}}
                      onClick={() => setForm({...form, postcard_data: {...form.postcard_data, backgrounds: form.postcard_data.backgrounds.filter((_, x) => x !== i)}})}>×</button>
                  </div>
                ))}
              </div>
              <FileUpload label="+ Добавить фон" currentUrl=""
                onUploaded={url => setForm(prev => ({...prev, postcard_data: {...prev.postcard_data, backgrounds: [...((prev.postcard_data && prev.postcard_data.backgrounds) || []), url]}}))} />
            </div>
            <div className="admin-field" style={{background: '#f5f8fb', padding: 10, borderRadius: 8}}>
              <label className="admin-label" style={{fontWeight: 700}}>Наклейки</label>
              <div style={{fontSize: 11, color: '#888', marginBottom: 8}}>Маленькие картинки с прозрачным фоном (PNG): сердечки, звёзды, эмодзи, символы города. Турист нажимает — наклейка появляется на открытке.</div>
              <div style={{display: 'flex', flexWrap: 'wrap', gap: 8, marginBottom: 8}}>
                {((form.postcard_data && form.postcard_data.stickers) || []).map((u, i) => (
                  <div key={i} style={{position: 'relative'}}>
                    <img src={BASE_URL + u} alt="" style={{width: 48, height: 48, objectFit: 'contain', borderRadius: 6, border: '1px solid #ddd', background: '#fff'}} />
                    <button type="button" className="admin-btn small danger" style={{position: 'absolute', top: -8, right: -8, padding: '0 6px'}}
                      onClick={() => setForm({...form, postcard_data: {...form.postcard_data, stickers: form.postcard_data.stickers.filter((_, x) => x !== i)}})}>×</button>
                  </div>
                ))}
              </div>
              <FileUpload label="+ Добавить наклейку" currentUrl=""
                onUploaded={url => setForm(prev => ({...prev, postcard_data: {...prev.postcard_data, stickers: [...((prev.postcard_data && prev.postcard_data.stickers) || []), url]}}))} />
            </div>
            <div style={{fontSize: 11, color: '#aaa', marginBottom: 8}}>Турист выберет фон, добавит наклейки, впишет текст и скачает открытку картинкой. Баллов нет — творческий элемент.</div>
          </>) : form.question_type === 'phrase' ? (<>
            <div className="admin-field" style={{background: '#f5f8fb', padding: 10, borderRadius: 8}}>
              <label className="admin-label" style={{fontWeight: 700}}>Карточки фразы (в правильном порядке)</label>
              <div style={{fontSize: 11, color: '#888', marginBottom: 8}}>Добавьте карточки СВЕРХУ ВНИЗ в том порядке, в каком они должны стоять во фразе. Каждая карточка — одно слово, или картинка, или то и другое. Игроку они покажутся перемешанными — нужно перетащить в рамку в правильном порядке.</div>
              {((form.phrase_data && form.phrase_data.cards) || []).map((it, i) => (
                <div key={i} style={{borderTop: i > 0 ? '1px solid #dde3ea' : 'none', paddingTop: i > 0 ? 12 : 0, marginTop: i > 0 ? 12 : 0}}>
                  <div style={{fontWeight: 700, fontSize: 13, marginBottom: 6}}>Позиция {i + 1}</div>
                  <input className="admin-input" style={{marginBottom: 6}} placeholder="Слово (необязательно, если есть картинка)"
                    value={it.text || ''} onChange={e => { const a = [...form.phrase_data.cards]; a[i] = {...a[i], text: e.target.value}; setForm({...form, phrase_data: {...form.phrase_data, cards: a}}); }} />
                  <FileUpload label="Картинка (необязательно)" currentUrl={it.image || ''}
                    onUploaded={url => setForm(prev => { const a = [...prev.phrase_data.cards]; a[i] = {...a[i], image: url}; return {...prev, phrase_data: {...prev.phrase_data, cards: a}}; })} />
                  <div style={{display: 'flex', gap: 6, marginTop: 4}}>
                    <button type="button" className="admin-btn small" disabled={i === 0}
                      onClick={() => { const a = [...form.phrase_data.cards]; [a[i - 1], a[i]] = [a[i], a[i - 1]]; setForm({...form, phrase_data: {...form.phrase_data, cards: a}}); }}>↑ выше</button>
                    <button type="button" className="admin-btn small" disabled={i === form.phrase_data.cards.length - 1}
                      onClick={() => { const a = [...form.phrase_data.cards]; [a[i + 1], a[i]] = [a[i], a[i + 1]]; setForm({...form, phrase_data: {...form.phrase_data, cards: a}}); }}>↓ ниже</button>
                    <button type="button" className="admin-btn small danger"
                      onClick={() => setForm({...form, phrase_data: {...form.phrase_data, cards: form.phrase_data.cards.filter((_, x) => x !== i)}})}>Удалить</button>
                  </div>
                </div>
              ))}
              <button type="button" className="admin-btn small" style={{marginTop: 10}}
                onClick={() => setForm({...form, phrase_data: {...form.phrase_data, cards: [...((form.phrase_data && form.phrase_data.cards) || []), { text: '', image: '' }]}})}>+ Добавить карточку фразы</button>
            </div>
            <div className="admin-field" style={{background: '#fff8e1', padding: 10, borderRadius: 8}}>
              <label className="admin-label" style={{fontWeight: 700}}>Лишние карточки (отвлекающие — необязательно)</label>
              <div style={{fontSize: 11, color: '#888', marginBottom: 8}}>Эти карточки тоже попадут в общую кучу — игрок должен их НЕ брать. Усложняет задачу. Если оставить пусто — игрок просто расставит карточки фразы по порядку.</div>
              {((form.phrase_data && form.phrase_data.extras) || []).map((it, i) => (
                <div key={i} style={{borderTop: i > 0 ? '1px solid #ead9a1' : 'none', paddingTop: i > 0 ? 12 : 0, marginTop: i > 0 ? 12 : 0}}>
                  <div style={{fontWeight: 700, fontSize: 13, marginBottom: 6}}>Лишняя {i + 1}</div>
                  <input className="admin-input" style={{marginBottom: 6}} placeholder="Слово (необязательно, если есть картинка)"
                    value={it.text || ''} onChange={e => { const a = [...form.phrase_data.extras]; a[i] = {...a[i], text: e.target.value}; setForm({...form, phrase_data: {...form.phrase_data, extras: a}}); }} />
                  <FileUpload label="Картинка (необязательно)" currentUrl={it.image || ''}
                    onUploaded={url => setForm(prev => { const a = [...prev.phrase_data.extras]; a[i] = {...a[i], image: url}; return {...prev, phrase_data: {...prev.phrase_data, extras: a}}; })} />
                  <button type="button" className="admin-btn small danger" style={{marginTop: 4}}
                    onClick={() => setForm({...form, phrase_data: {...form.phrase_data, extras: form.phrase_data.extras.filter((_, x) => x !== i)}})}>Удалить</button>
                </div>
              ))}
              <button type="button" className="admin-btn small" style={{marginTop: 10}}
                onClick={() => setForm({...form, phrase_data: {...form.phrase_data, extras: [...((form.phrase_data && form.phrase_data.extras) || []), { text: '', image: '' }]}})}>+ Добавить лишнюю</button>
            </div>
            <div className="admin-field"><label className="admin-label">Балл за верно собранную фразу</label>
              <input className="admin-input" type="number" value={form.points} onChange={e => setForm({...form, points: e.target.value})} placeholder="0" />
              <div style={{fontSize: 11, color: '#aaa', marginTop: 4}}>Начисляется один раз, если вся фраза собрана верно. Работает только если у экскурсии включён «Квест с баллами».</div>
            </div>
          </>) : form.question_type === 'pairs' ? (<>
            <div className="admin-field" style={{background: '#f5f8fb', padding: 10, borderRadius: 8}}>
              <label className="admin-label" style={{fontWeight: 700}}>Пары карточек</label>
              <div style={{fontSize: 11, color: '#888', marginBottom: 8}}>Каждая пара — две карточки, которые подходят друг другу (фото↔факт, термин↔определение). У карточки может быть текст и/или картинка. На поле всё перемешивается рубашкой вверх.</div>
              <FileUpload label="Картинка рубашки (необязательно) — напр. логотип клиента"
                currentUrl={(form.pairs_data && form.pairs_data.back_image) || ''}
                onUploaded={url => setForm(prev => ({ ...prev, pairs_data: { ...prev.pairs_data, back_image: url } }))} />
              <div style={{fontSize: 11, color: '#aaa', margin: '4px 0 10px'}}>Показывается на закрытых карточках. Если пусто — синий фон со знаком «?». Лучше квадратная картинка.</div>
              {((form.pairs_data && form.pairs_data.pairs) || []).map((p, i) => {
                const upd = (side, field, val) => {
                  setForm(prev => {
                    const arr = [...prev.pairs_data.pairs];
                    arr[i] = { ...arr[i], [side]: { ...(arr[i][side] || {}), [field]: val } };
                    return { ...prev, pairs_data: { ...prev.pairs_data, pairs: arr } };
                  });
                };
                return (
                  <div key={i} style={{borderTop: i > 0 ? '1px solid #dde3ea' : 'none', paddingTop: i > 0 ? 12 : 0, marginTop: i > 0 ? 12 : 0}}>
                    <div style={{fontWeight: 700, fontSize: 13, marginBottom: 6}}>Пара {i + 1}</div>
                    <div style={{fontSize: 12, color: '#666', margin: '4px 0'}}>Карточка А</div>
                    <input className="admin-input" style={{marginBottom: 6}} placeholder="Текст (необязательно, если есть картинка)"
                      value={(p.a && p.a.text) || ''} onChange={e => upd('a', 'text', e.target.value)} />
                    <FileUpload label="Картинка А (необязательно)" currentUrl={(p.a && p.a.image) || ''}
                      onUploaded={url => upd('a', 'image', url)} />
                    <div style={{fontSize: 12, color: '#666', margin: '8px 0 4px'}}>Карточка Б</div>
                    <input className="admin-input" style={{marginBottom: 6}} placeholder="Текст (необязательно, если есть картинка)"
                      value={(p.b && p.b.text) || ''} onChange={e => upd('b', 'text', e.target.value)} />
                    <FileUpload label="Картинка Б (необязательно)" currentUrl={(p.b && p.b.image) || ''}
                      onUploaded={url => upd('b', 'image', url)} />
                    <button type="button" className="admin-btn small danger" style={{marginTop: 6}}
                      onClick={() => setForm({ ...form, pairs_data: { ...form.pairs_data, pairs: form.pairs_data.pairs.filter((_, x) => x !== i) } })}>Удалить пару</button>
                  </div>
                );
              })}
              <button type="button" className="admin-btn small" style={{marginTop: 10}}
                onClick={() => setForm({ ...form, pairs_data: { ...form.pairs_data, pairs: [...((form.pairs_data && form.pairs_data.pairs) || []), { a: { text: '', image: '' }, b: { text: '', image: '' } }] } })}>+ Добавить пару</button>
            </div>
            <div className="admin-field"><label className="admin-label">Баллы за каждую найденную пару</label>
              <input className="admin-input" type="number" value={form.points} onChange={e => setForm({...form, points: e.target.value})} placeholder="0" />
              <div style={{fontSize: 11, color: '#aaa', marginTop: 4}}>Работает только если у экскурсии включён «Квест с баллами». Иначе оставьте 0.</div>
            </div>
          </>) : form.question_type === 'ice' ? (<>
            <div className="admin-field" style={{background: '#f5f8fb', padding: 10, borderRadius: 8}}>
              <label className="admin-label" style={{fontWeight: 700}}>Разбей лёд</label>
              <div style={{fontSize: 11, color: '#888', marginBottom: 8}}>Экран «заморожен». Турист много раз бьёт пальцем — появляются трещины, лёд осыпается, под ним открывается фото и текст. Это не вопрос — баллов нет.</div>
              <FileUpload label="Спрятанное фото (что подо льдом)" currentUrl={(form.ice && form.ice.image) || ''}
                onUploaded={url => setForm(prev => ({...prev, ice: {...prev.ice, image: url}}))} />
              <label className="admin-label" style={{marginTop: 8}}>Сколько ударов нужно (5–60)</label>
              <input className="admin-input" type="number" min={5} max={60}
                value={(form.ice && form.ice.taps) || 15}
                onChange={e => setForm({...form, ice: {...form.ice, taps: e.target.value}})} />
              <input className="admin-input" style={{marginTop: 8}} placeholder="Текст после открытия (необязательно)"
                value={(form.ice && form.ice.caption) || ''}
                onChange={e => setForm({...form, ice: {...form.ice, caption: e.target.value}})} />
            </div>
          </>) : form.question_type === 'memseq' ? (<>
            <div className="admin-field" style={{background: '#f5f8fb', padding: 10, borderRadius: 8}}>
              <label className="admin-label" style={{fontWeight: 700}}>Игра на память «Повтори цвета»</label>
              <div style={{fontSize: 11, color: '#888', marginBottom: 8}}>3 кнопки (красная/синяя/зелёная). Игроку показывается случайная последовательность цветов (дважды), он повторяет её. При успехе открывается фото/текст. Последовательность генерируется случайно при каждом прохождении.</div>
              <label className="admin-label">Длина последовательности (сколько цветов, 2–8)</label>
              <input className="admin-input" type="number" min={2} max={8}
                value={(form.memseq && form.memseq.length) || 4}
                onChange={e => setForm({...form, memseq: {...form.memseq, length: e.target.value}})} />
              <div style={{marginTop: 10}}>
                <FileUpload label="Фото-награда (откроется при успехе, необязательно)" currentUrl={(form.memseq && form.memseq.reveal_image) || ''}
                  onUploaded={url => setForm(prev => ({...prev, memseq: {...prev.memseq, reveal_image: url}}))} />
              </div>
              <input className="admin-input" style={{marginTop: 8}} placeholder="Текст-награда при успехе (необязательно)"
                value={(form.memseq && form.memseq.reveal_text) || ''}
                onChange={e => setForm({...form, memseq: {...form.memseq, reveal_text: e.target.value}})} />
            </div>
            <div className="admin-field"><label className="admin-label">Балл за успех</label>
              <input className="admin-input" type="number" value={form.points} onChange={e => setForm({...form, points: e.target.value})} placeholder="0" />
              <div style={{fontSize: 11, color: '#aaa', marginTop: 4}}>Начисляется один раз при верном повторе. Работает только если у экскурсии включён «Квест с баллами».</div>
            </div>
          </>) : form.question_type === 'scratch' ? (<>
            <div className="admin-field" style={{background: '#f5f8fb', padding: 10, borderRadius: 8}}>
              <label className="admin-label" style={{fontWeight: 700}}>Скретч-сюрприз</label>
              <div style={{fontSize: 11, color: '#888', marginBottom: 8}}>Турист стирает пальцем серый слой и под ним открывается это фото. Хорошо для подарка/бонуса от партнёра или эффектного кадра. Это не вопрос — баллов нет.</div>
              <FileUpload label="Спрятанное фото (что откроется)" currentUrl={(form.scratch && form.scratch.image) || ''}
                onUploaded={url => setForm(prev => ({...prev, scratch: {...prev.scratch, image: url}}))} />
              <input className="admin-input" style={{marginTop: 8}} placeholder="Надпись на слое (напр. «Сотрите, чтобы открыть подарок»)"
                value={(form.scratch && form.scratch.cover_label) || ''}
                onChange={e => setForm({...form, scratch: {...form.scratch, cover_label: e.target.value}})} />
              <input className="admin-input" style={{marginTop: 8}} placeholder="Текст после открытия (необязательно), напр. промокод"
                value={(form.scratch && form.scratch.caption) || ''}
                onChange={e => setForm({...form, scratch: {...form.scratch, caption: e.target.value}})} />
            </div>
          </>) : form.question_type === 'beforeafter' ? (<>
            <div className="admin-field" style={{background: '#f5f8fb', padding: 10, borderRadius: 8}}>
              <label className="admin-label" style={{fontWeight: 700}}>Сравнение «Тогда / Сейчас»</label>
              <div style={{fontSize: 11, color: '#888', marginBottom: 8}}>Турист двигает ползунок по фото и сравнивает два изображения. Это не вопрос — баллов нет, просто атмосферный элемент. Лучше брать кадры с одного ракурса.</div>
              <FileUpload label="Левое фото (например, архивное «Тогда»)" currentUrl={(form.beforeafter && form.beforeafter.before) || ''}
                onUploaded={url => setForm(prev => ({...prev, beforeafter: {...prev.beforeafter, before: url}}))} />
              <input className="admin-input" style={{marginTop: 6, marginBottom: 10}} placeholder="Подпись слева (необязательно), напр. «1900 год»"
                value={(form.beforeafter && form.beforeafter.before_label) || ''}
                onChange={e => setForm({...form, beforeafter: {...form.beforeafter, before_label: e.target.value}})} />
              <FileUpload label="Правое фото (например, современное «Сейчас»)" currentUrl={(form.beforeafter && form.beforeafter.after) || ''}
                onUploaded={url => setForm(prev => ({...prev, beforeafter: {...prev.beforeafter, after: url}}))} />
              <input className="admin-input" style={{marginTop: 6}} placeholder="Подпись справа (необязательно), напр. «Сегодня»"
                value={(form.beforeafter && form.beforeafter.after_label) || ''}
                onChange={e => setForm({...form, beforeafter: {...form.beforeafter, after_label: e.target.value}})} />
            </div>
          </>) : form.question_type === 'order' ? (<>
            <div className="admin-field" style={{background: '#f5f8fb', padding: 10, borderRadius: 8}}>
              <label className="admin-label" style={{fontWeight: 700}}>Элементы в правильном порядке</label>
              <div style={{fontSize: 11, color: '#888', marginBottom: 8}}>Добавьте элементы (слова и/или картинки) сверху вниз в ПРАВИЛЬНОМ порядке. Игроку они покажутся перемешанными — нужно расставить так же.</div>
              {(form.order_items || []).map((it, i) => (
                <div key={i} style={{borderTop: i > 0 ? '1px solid #dde3ea' : 'none', paddingTop: i > 0 ? 12 : 0, marginTop: i > 0 ? 12 : 0}}>
                  <div style={{fontWeight: 700, fontSize: 13, marginBottom: 6}}>Позиция {i + 1}</div>
                  <input className="admin-input" style={{marginBottom: 6}} placeholder="Слово (необязательно, если есть картинка)"
                    value={it.text || ''} onChange={e => { const a = [...form.order_items]; a[i] = {...a[i], text: e.target.value}; setForm({...form, order_items: a}); }} />
                  <FileUpload label="Картинка (необязательно)" currentUrl={it.image || ''}
                    onUploaded={url => setForm(prev => { const a = [...prev.order_items]; a[i] = {...a[i], image: url}; return {...prev, order_items: a}; })} />
                  <div style={{display: 'flex', gap: 6, marginTop: 4}}>
                    <button type="button" className="admin-btn small" disabled={i === 0}
                      onClick={() => { const a = [...form.order_items]; [a[i - 1], a[i]] = [a[i], a[i - 1]]; setForm({...form, order_items: a}); }}>↑ выше</button>
                    <button type="button" className="admin-btn small" disabled={i === form.order_items.length - 1}
                      onClick={() => { const a = [...form.order_items]; [a[i + 1], a[i]] = [a[i], a[i + 1]]; setForm({...form, order_items: a}); }}>↓ ниже</button>
                    <button type="button" className="admin-btn small danger"
                      onClick={() => setForm({...form, order_items: form.order_items.filter((_, x) => x !== i)})}>Удалить</button>
                  </div>
                </div>
              ))}
              <button type="button" className="admin-btn small" style={{marginTop: 10}}
                onClick={() => setForm({...form, order_items: [...(form.order_items || []), { text: '', image: '' }]})}>+ Добавить элемент</button>
            </div>
            <div className="admin-field"><label className="admin-label">Балл за верный порядок</label>
              <input className="admin-input" type="number" value={form.points} onChange={e => setForm({...form, points: e.target.value})} placeholder="0" />
              <div style={{fontSize: 11, color: '#aaa', marginTop: 4}}>Начисляется один раз, если весь порядок верный. Работает только если у экскурсии включён «Квест с баллами».</div>
            </div>
          </>) : form.question_type === 'dish' ? (<>
            <div className="admin-field">
              <label className="admin-label">Название контейнера</label>
              <input className="admin-input" placeholder="Например: Тарелка, Чемодан, Номер"
                value={(form.dish_data && form.dish_data.container_title) || ''}
                onChange={e => setForm({...form, dish_data: {...form.dish_data, container_title: e.target.value}})} />
              <div style={{fontSize: 11, color: '#aaa', marginTop: 4}}>Куда игрок перетаскивает нужные элементы.</div>
            </div>
            <div className="admin-field" style={{background: '#f5f8fb', padding: 10, borderRadius: 8}}>
              <label className="admin-label" style={{fontWeight: 700}}>Элементы</label>
              <div style={{fontSize: 11, color: '#888', marginBottom: 8}}>Загрузите картинки (и/или слова). Отметьте галочкой те, что должны попасть в «{(form.dish_data && form.dish_data.container_title) || 'контейнер'}». Без галочки — лишние (отвлекающие).</div>
              {(form.dish_data.items || []).map((it, i) => (
                <div key={i} style={{borderTop: i > 0 ? '1px solid #dde3ea' : 'none', paddingTop: i > 0 ? 12 : 0, marginTop: i > 0 ? 12 : 0}}>
                  <div style={{fontWeight: 700, fontSize: 13, marginBottom: 6}}>Элемент {i + 1}</div>
                  <input className="admin-input" style={{marginBottom: 6}} placeholder="Слово (необязательно, если есть картинка)"
                    value={it.text || ''} onChange={e => { const a = [...form.dish_data.items]; a[i] = {...a[i], text: e.target.value}; setForm({...form, dish_data: {...form.dish_data, items: a}}); }} />
                  <label className="admin-label" style={{display: 'flex', alignItems: 'center', gap: 6, marginBottom: 6}}>
                    <input type="checkbox" checked={!!it.correct}
                      onChange={e => { const a = [...form.dish_data.items]; a[i] = {...a[i], correct: e.target.checked}; setForm({...form, dish_data: {...form.dish_data, items: a}}); }} />
                    Входит в набор (правильный элемент)
                  </label>
                  <FileUpload label="Картинка элемента" currentUrl={it.image || ''}
                    onUploaded={url => setForm(prev => { const a = [...prev.dish_data.items]; a[i] = {...a[i], image: url}; return {...prev, dish_data: {...prev.dish_data, items: a}}; })} />
                  <button type="button" className="admin-btn small danger"
                    onClick={() => setForm({...form, dish_data: {...form.dish_data, items: form.dish_data.items.filter((_, x) => x !== i)}})}>Удалить элемент</button>
                </div>
              ))}
              <button type="button" className="admin-btn small" style={{marginTop: 10}}
                onClick={() => setForm({...form, dish_data: {...form.dish_data, items: [...(form.dish_data.items || []), { text: '', image: '', correct: false }]}})}>+ Добавить элемент</button>
            </div>
            <div className="admin-field"><label className="admin-label">Балл за правильную сборку</label>
              <input className="admin-input" type="number" value={form.points} onChange={e => setForm({...form, points: e.target.value})} placeholder="0" />
              <div style={{fontSize: 11, color: '#aaa', marginTop: 4}}>Начисляется один раз, если набор собран полностью верно. Работает только если у экскурсии включён «Квест с баллами».</div>
            </div>
          </>) : form.question_type === 'sort' ? (<>
            <div className="admin-field" style={{background: '#f5f8fb', padding: 10, borderRadius: 8}}>
              <label className="admin-label" style={{fontWeight: 700}}>Категории (корзины)</label>
              <div style={{fontSize: 11, color: '#888', marginBottom: 8}}>Например: SPA, Ресторан, Детский маршрут. Минимум 2.</div>
              {(form.sort_data.categories || []).map((c, i) => (
                <div key={i} style={{display: 'flex', gap: 6, marginBottom: 6}}>
                  <input className="admin-input" style={{flex: 1}} placeholder={`Категория ${i + 1}`} value={c}
                    onChange={e => { const a = [...form.sort_data.categories]; a[i] = e.target.value; setForm({...form, sort_data: {...form.sort_data, categories: a}}); }} />
                  <button type="button" className="admin-btn small danger"
                    onClick={() => { const a = form.sort_data.categories.filter((_, x) => x !== i);
                      const items = (form.sort_data.items || []).map(it => ({...it, cat: it.cat === i ? 0 : (it.cat > i ? it.cat - 1 : it.cat)}));
                      setForm({...form, sort_data: {...form.sort_data, categories: a, items}}); }}>×</button>
                </div>
              ))}
              <button type="button" className="admin-btn small"
                onClick={() => setForm({...form, sort_data: {...form.sort_data, categories: [...(form.sort_data.categories || []), '']}})}>+ Добавить категорию</button>
            </div>
            <div className="admin-field" style={{background: '#f5f8fb', padding: 10, borderRadius: 8}}>
              <label className="admin-label" style={{fontWeight: 700}}>Элементы</label>
              <div style={{fontSize: 11, color: '#888', marginBottom: 8}}>У элемента может быть слово и/или картинка. Укажите, в какую категорию он должен попасть.</div>
              {(form.sort_data.items || []).map((it, i) => (
                <div key={i} style={{borderTop: i > 0 ? '1px solid #dde3ea' : 'none', paddingTop: i > 0 ? 12 : 0, marginTop: i > 0 ? 12 : 0}}>
                  <div style={{fontWeight: 700, fontSize: 13, marginBottom: 6}}>Элемент {i + 1}</div>
                  <input className="admin-input" style={{marginBottom: 6}} placeholder="Слово (необязательно, если есть картинка)"
                    value={it.text || ''} onChange={e => { const a = [...form.sort_data.items]; a[i] = {...a[i], text: e.target.value}; setForm({...form, sort_data: {...form.sort_data, items: a}}); }} />
                  <select className="admin-input" style={{marginBottom: 6}} value={it.cat || 0}
                    onChange={e => { const a = [...form.sort_data.items]; a[i] = {...a[i], cat: parseInt(e.target.value)}; setForm({...form, sort_data: {...form.sort_data, items: a}}); }}>
                    {(form.sort_data.categories || []).length === 0 && <option value={0}>Сначала добавьте категории</option>}
                    {(form.sort_data.categories || []).map((c, ci) => <option key={ci} value={ci}>{c || `Категория ${ci + 1}`}</option>)}
                  </select>
                  <FileUpload label="Картинка элемента (необязательно)" currentUrl={it.image || ''}
                    onUploaded={url => setForm(prev => { const a = [...prev.sort_data.items]; a[i] = {...a[i], image: url}; return {...prev, sort_data: {...prev.sort_data, items: a}}; })} />
                  <button type="button" className="admin-btn small danger"
                    onClick={() => setForm({...form, sort_data: {...form.sort_data, items: form.sort_data.items.filter((_, x) => x !== i)}})}>Удалить элемент</button>
                </div>
              ))}
              <button type="button" className="admin-btn small" style={{marginTop: 10}}
                onClick={() => setForm({...form, sort_data: {...form.sort_data, items: [...(form.sort_data.items || []), { text: '', image: '', cat: 0 }]}})}>+ Добавить элемент</button>
            </div>
            <div className="admin-field"><label className="admin-label">Баллы за каждый верно разложенный элемент</label>
              <input className="admin-input" type="number" value={form.points} onChange={e => setForm({...form, points: e.target.value})} placeholder="0" />
              <div style={{fontSize: 11, color: '#aaa', marginTop: 4}}>Работает только если у экскурсии включён «Квест с баллами». Иначе оставьте 0.</div>
            </div>
          </>) : form.question_type === 'puzzle' ? (<>
            <div className="admin-field" style={{background: '#f5f8fb', padding: 10, borderRadius: 8}}>
              <label className="admin-label" style={{fontWeight: 700}}>Пазл</label>
              <div style={{fontSize: 11, color: '#888', marginBottom: 8}}>Картинка режется на квадраты и перемешивается. Турист нажимает на две плитки — они меняются местами. Когда картинка собрана — успех.</div>
              <FileUpload label="Картинка пазла" currentUrl={(form.puzzle && form.puzzle.image) || ''}
                onUploaded={url => setForm(prev => ({...prev, puzzle: {...prev.puzzle, image: url}}))} />
              <label className="admin-label" style={{marginTop: 8}}>Сложность (на сколько частей резать)</label>
              <select className="admin-input" value={(form.puzzle && form.puzzle.size) || 3}
                onChange={e => setForm({...form, puzzle: {...form.puzzle, size: parseInt(e.target.value)}})}>
                <option value={3}>3 × 3 — легко (9 частей)</option>
                <option value={4}>4 × 4 — средне (16 частей)</option>
                <option value={5}>5 × 5 — сложно (25 частей)</option>
                <option value={6}>6 × 6 — очень сложно (36 частей)</option>
              </select>
            </div>
            <div className="admin-field"><label className="admin-label">Баллы за собранный пазл</label>
              <input className="admin-input" type="number" value={form.points} onChange={e => setForm({...form, points: e.target.value})} placeholder="0" />
              <div style={{fontSize: 11, color: '#aaa', marginTop: 4}}>Работает только если у экскурсии включён «Квест с баллами». Иначе оставьте 0.</div>
            </div>
          </>) : form.question_type === 'swipe' ? (<>
            <div className="admin-field" style={{background: '#f5f8fb', padding: 10, borderRadius: 8}}>
              <label className="admin-label" style={{fontWeight: 700}}>Карточки викторины</label>
              <div style={{fontSize: 11, color: '#888', marginBottom: 8}}>Турист смахивает каждую карточку: вправо — «Верю», влево — «Не верю». После каждого ответа игрок видит, верно ли он ответил, и ваше пояснение (если указано). К каждой можно добавить фото.</div>
              {(form.swipe_cards || []).map((card, i) => (
                <div key={i} style={{borderTop: i > 0 ? '1px solid #dde3ea' : 'none', paddingTop: i > 0 ? 12 : 0, marginTop: i > 0 ? 12 : 0}}>
                  <div style={{fontWeight: 700, fontSize: 13, marginBottom: 6}}>Карточка {i + 1}</div>
                  <input className="admin-input" style={{marginBottom: 6}} placeholder="Утверждение (например: Эта башня построена в 1850 году)"
                    value={card.text || ''} onChange={e => { const a = [...form.swipe_cards]; a[i] = {...a[i], text: e.target.value}; setForm({...form, swipe_cards: a}); }} />
                  <select className="admin-input" style={{marginBottom: 6}} value={card.answer === 'не верю' ? 'не верю' : 'верю'}
                    onChange={e => { const a = [...form.swipe_cards]; a[i] = {...a[i], answer: e.target.value}; setForm({...form, swipe_cards: a}); }}>
                    <option value="верю">Правильно: Верю (утверждение правдивое)</option>
                    <option value="не верю">Правильно: Не верю (утверждение ложное)</option>
                  </select>
                  <FileUpload label="Фото карточки (необязательно)" currentUrl={card.image || ''}
                    onUploaded={url => setForm(prev => { const a = [...prev.swipe_cards]; a[i] = {...a[i], image: url}; return {...prev, swipe_cards: a}; })} />
                  <textarea className="admin-input" style={{marginTop: 6, minHeight: 60}}
                    placeholder="Пояснение после ответа (необязательно). Например: «На самом деле башню построили в 1902 году — это подарок купца Морозова»"
                    value={card.comment || ''}
                    onChange={e => { const a = [...form.swipe_cards]; a[i] = {...a[i], comment: e.target.value}; setForm({...form, swipe_cards: a}); }} />
                  <button type="button" className="admin-btn small danger"
                    onClick={() => setForm({...form, swipe_cards: form.swipe_cards.filter((_, idx) => idx !== i)})}>Удалить карточку</button>
                </div>
              ))}
              <button type="button" className="admin-btn small" style={{marginTop: 10}}
                onClick={() => setForm({...form, swipe_cards: [...(form.swipe_cards || []), { text: '', answer: 'верю', image: '', comment: '' }]})}>+ Добавить карточку</button>
            </div>
            <div className="admin-field"><label className="admin-label">Баллы за каждую верную карточку</label>
              <input className="admin-input" type="number" value={form.points} onChange={e => setForm({...form, points: e.target.value})} placeholder="0" />
              <div style={{fontSize: 11, color: '#aaa', marginTop: 4}}>Например, 1 балл за карточку. Работает только если у экскурсии включён «Квест с баллами». Иначе оставьте 0.</div>
            </div>
          </>) : (<>
            <div className="admin-field"><label className="admin-label">Вопрос</label><input className="admin-input" value={form.question} onChange={e => setForm({...form, question: e.target.value})} /></div>
            {form.question_type === 'choice' && (
              <div className="admin-field">
                <label className="admin-label">Варианты ответа (каждый с новой строки)</label>
                <textarea className="admin-textarea" rows={4} value={optionsText} onChange={e => setOptionsText(e.target.value)} placeholder={"фонтан\nбокалы в ресторане\nканатная дорога\nручей"} />
                <div style={{fontSize: 11, color: '#aaa', marginTop: 4}}>Эти варианты показываются кнопками. Правильный(е) укажите ниже в поле «Ответы» точно как в варианте.</div>
              </div>
            )}
            <div className="admin-field"><label className="admin-label">Ответы {form.question_type === 'choice' ? '(правильный вариант — точно как в списке выше)' : '(через запятую)'}</label><input className="admin-input" value={answersText} onChange={e => setAnswersText(e.target.value)} placeholder={form.question_type === 'choice' ? 'канатная дорога' : '5, пять'} /></div>
            <div className="admin-field"><label className="admin-label">Подсказка</label><input className="admin-input" value={form.hint} onChange={e => setForm({...form, hint: e.target.value})} /></div>
            <div className="admin-row">
              <div className="admin-field" style={{flex: 1}}><label className="admin-label">Баллы за правильный ответ</label><input className="admin-input" type="number" value={form.points} onChange={e => setForm({...form, points: e.target.value})} placeholder="0" /></div>
              <div className="admin-field" style={{flex: 1}}><label className="admin-label">Штраф за подсказку</label><input className="admin-input" type="number" value={form.hint_penalty} onChange={e => setForm({...form, hint_penalty: e.target.value})} placeholder="0" /></div>
            </div>
            <div style={{fontSize: 11, color: '#aaa', marginTop: -6, marginBottom: 8}}>Работает только если у экскурсии включён «Квест с баллами». Для обычной экскурсии оставьте 0.</div>
          </>)}
          <div className="admin-field" style={{background: '#eef9f1', padding: 10, borderRadius: 8, marginTop: 8}}>
            <label className="admin-label" style={{fontWeight: 700}}>🎯 Разоблачение после ответа (необязательно)</label>
            <div style={{fontSize: 11, color: '#888', marginBottom: 8}}>Показывается, когда игрок ответил верно ИЛИ исчерпал попытки. Например: фото без зелёных кружков с реальным ответом, или просто текст ответа. Если ничего не заполнить — поведение как раньше.</div>
            <FileUpload label="Картинка с разоблачением" currentUrl={form.reveal_image || ''}
              onUploaded={url => setForm(prev => ({...prev, reveal_image: url}))} />
            {form.reveal_image && (
              <button type="button" className="admin-btn small danger" style={{marginTop: 4}}
                onClick={() => setForm({...form, reveal_image: ''})}>Убрать картинку</button>
            )}
            <label className="admin-label" style={{marginTop: 10}}>Текст разоблачения</label>
            <textarea className="admin-textarea" rows={3} value={form.reveal_text || ''}
              onChange={e => setForm({...form, reveal_text: e.target.value})}
              placeholder="Например: «Мяч прилетел сюда — точка 3». Можно оставить пусто, если есть картинка." />
            <div style={{fontSize: 11, color: '#aaa', marginTop: 4}}>Картинка и текст показываются вместе. Можно заполнить только одно.</div>
            <div style={{borderTop: '1px dashed #c8e6c9', marginTop: 12, paddingTop: 10}}>
              <label className="admin-label">
                <input type="checkbox" checked={!!form.allow_reveal}
                  onChange={e => setForm({...form, allow_reveal: e.target.checked})} />
                {' '}<b>Показать кнопку «Узнать ответ»</b>
              </label>
              <div style={{fontSize: 11, color: '#888', marginTop: 4}}>Игрок сможет сдаться и посмотреть правильный ответ (те же картинка + текст, что выше). Идёт как «сдался» — баллы не начисляются, но переход к следующему шагу открывается. Полезно, если задание сложное и не хочется, чтобы человек застрял.</div>
            </div>
          </div>
        </>)}
        <div className="admin-field"><label className="admin-label"><input type="checkbox" checked={form.has_fun_fact} onChange={e => setForm({...form, has_fun_fact: e.target.checked})} /> Интересный факт</label></div>
        {form.has_fun_fact && (<>
          <div className="admin-field"><label className="admin-label">Текст интересного факта</label>
            <textarea className="admin-textarea" rows={4} value={form.fun_fact_text} onChange={e => setForm({...form, fun_fact_text: e.target.value})} placeholder="Расскажите интересную историю про это место..." />
            <div style={{fontSize: 11, color: '#aaa', marginTop: 4}}>Поддерживается **жирный**, *курсив*, [size:18]размер[/size], [align:center]центр[/align]</div>
          </div>
          <div className="admin-fun-facts">
            {form.fun_fact_images.map((url, i) => (<div key={i} className="admin-fun-fact-item">
              <img src={BASE_URL + url} alt="" style={{width: 60, height: 60, objectFit: 'cover', borderRadius: 8}} />
              <button className="admin-btn small danger" onClick={() => removeFunFactImage(i)}>×</button>
            </div>))}
            <FileUpload label="Добавить фото" currentUrl="" onUploaded={addFunFactImage} />
          </div>
        </>)}
        <div className="admin-field"><label className="admin-label"><input type="checkbox" checked={form.has_video} onChange={e => setForm({...form, has_video: e.target.checked})} /> Видео</label></div>
        {form.has_video && <FileUpload label="Видео" currentUrl={form.video_url} onUploaded={url => setForm(prev => ({...prev, video_url: url}))} />}
        {langEd.isDefault && <StepBuilderFields form={form} setForm={setForm} />}
        <div style={{borderTop: '1px solid #eee', paddingTop: 12, marginTop: 8}}>
          <div className="admin-label" style={{marginBottom: 8, fontWeight: 700}}>📍 Карта / местоположение</div>
          <AdminMapPicker lat={form.lat} lng={form.lng} onSelect={(lat, lng) => setForm({...form, lat: String(lat), lng: String(lng)})} />
          <div className="admin-row" style={{marginTop: 8}}>
            <div className="admin-field" style={{flex: 1}}><label className="admin-label">Широта</label>
              <input className="admin-input" type="text" value={form.lat} onChange={e => setForm({...form, lat: e.target.value})} placeholder="25.2636" /></div>
            <div className="admin-field" style={{flex: 1}}><label className="admin-label">Долгота</label>
              <input className="admin-input" type="text" value={form.lng} onChange={e => setForm({...form, lng: e.target.value})} placeholder="55.2997" /></div>
          </div>
          <FileUpload label="Или картинка маршрута (для парков, отелей)" currentUrl={form.map_image_url} onUploaded={url => setForm(prev => ({...prev, map_image_url: url}))} />
        </div>
        <div className="admin-form-actions"><button className="admin-btn primary" onClick={save}>Сохранить</button><button className="admin-btn" onClick={() => setEditing(null)}>Отмена</button></div>
      </div>)}
      <div className="admin-list">
        {steps.map(s => (<div key={s.id} className="admin-list-item">
          <div className="admin-step-num">{s.step_number}</div>
          {s.image_url && <img src={BASE_URL + s.image_url} alt="" className="admin-list-thumb" />}
          <div className="admin-list-info"><strong>{s.title || `Шаг ${s.step_number}`}</strong>
            <span className="admin-list-sub">{s.has_question && '❓ '}{s.has_fun_fact && '💡 '}{s.has_video && '🎬 '}{s.audio_url && '🎧'}</span></div>
          <div className="admin-list-actions"><button className="admin-btn small" onClick={() => startEdit(s)}>Ред.</button><button className="admin-btn small danger" onClick={() => remove(s.id)}>Уд.</button></div>
        </div>))}
        {steps.length === 0 && <p className="admin-empty">Нет шагов</p>}
      </div>
    </>)}
  </div>);
}

// ===== PDF FLYER GENERATOR =====
async function generateFlyerPDF(selectedCodes, excursionTitle) {
  const pageW = 105;
  const pageH = 148;

  // Load background image and draw flyers on canvas, then convert to PDF
  const bgImg = await new Promise((resolve) => {
    const img = new Image();
    img.crossOrigin = 'anonymous';
    img.onload = () => resolve(img);
    img.onerror = () => resolve(null);
    img.src = '/flyer-bg.jpg';
  });

  // Use canvas to render each flyer, then add to PDF as image
  const pdf = new jsPDF({ orientation: 'portrait', unit: 'mm', format: [pageW, pageH] });
  const scale = 4; // high resolution
  const cW = pageW * scale;
  const cH = pageH * scale;

  for (let i = 0; i < selectedCodes.length; i++) {
    if (i > 0) pdf.addPage([pageW, pageH]);
    const code = selectedCodes[i];

    const canvas = document.createElement('canvas');
    canvas.width = cW;
    canvas.height = cH;
    const ctx = canvas.getContext('2d');

    // Background image
    if (bgImg) {
      const imgRatio = bgImg.width / bgImg.height;
      const canvasRatio = cW / cH;
      let sx = 0, sy = 0, sw = bgImg.width, sh = bgImg.height;
      if (imgRatio > canvasRatio) {
        sw = bgImg.height * canvasRatio;
        sx = (bgImg.width - sw) / 2;
      } else {
        sh = bgImg.width / canvasRatio;
        sy = (bgImg.height - sh) / 2;
      }
      ctx.drawImage(bgImg, sx, sy, sw, sh, 0, 0, cW, cH);
    } else {
      ctx.fillStyle = '#141428';
      ctx.fillRect(0, 0, cW, cH);
    }

    // Dark overlay top
    const gradTop = ctx.createLinearGradient(0, 0, 0, cH * 0.35);
    gradTop.addColorStop(0, 'rgba(0,0,0,0.7)');
    gradTop.addColorStop(1, 'rgba(0,0,0,0)');
    ctx.fillStyle = gradTop;
    ctx.fillRect(0, 0, cW, cH * 0.35);

    // Dark overlay bottom
    const gradBot = ctx.createLinearGradient(0, cH * 0.6, 0, cH);
    gradBot.addColorStop(0, 'rgba(0,0,0,0)');
    gradBot.addColorStop(1, 'rgba(0,0,0,0.8)');
    ctx.fillStyle = gradBot;
    ctx.fillRect(0, cH * 0.6, cW, cH * 0.4);

    // Title
    ctx.fillStyle = '#ffffff';
    ctx.textAlign = 'center';
    ctx.font = `bold ${scale * 9}px Arial, Helvetica, sans-serif`;
    ctx.fillText('КИНО В УШАХ', cW / 2, scale * 20);

    // Subtitle
    ctx.font = `${scale * 3}px Arial, Helvetica, sans-serif`;
    ctx.fillStyle = 'rgba(255,255,255,0.8)';
    ctx.fillText('САМОСТОЯТЕЛЬНАЯ АУДИО-ЭКСКУРСИЯ', cW / 2, scale * 28);
    ctx.fillText('В ФОРМАТЕ КИНО-ПОГРУЖЕНИЯ', cW / 2, scale * 33);

    // Excursion name
    const excName = (excursionTitle || 'ЭКСКУРСИЯ').toUpperCase();
    ctx.font = `bold ${scale * 6}px Arial, Helvetica, sans-serif`;
    ctx.fillStyle = '#ffffff';
    ctx.fillText(excName, cW / 2, cH - scale * 38);

    // Code box background
    const boxX = scale * 14;
    const boxY = cH - scale * 32;
    const boxW = cW - scale * 28;
    const boxH = scale * 16;
    const boxR = scale * 3;
    ctx.fillStyle = 'rgba(255,255,255,0.92)';
    ctx.beginPath();
    ctx.moveTo(boxX + boxR, boxY);
    ctx.lineTo(boxX + boxW - boxR, boxY);
    ctx.quadraticCurveTo(boxX + boxW, boxY, boxX + boxW, boxY + boxR);
    ctx.lineTo(boxX + boxW, boxY + boxH - boxR);
    ctx.quadraticCurveTo(boxX + boxW, boxY + boxH, boxX + boxW - boxR, boxY + boxH);
    ctx.lineTo(boxX + boxR, boxY + boxH);
    ctx.quadraticCurveTo(boxX, boxY + boxH, boxX, boxY + boxH - boxR);
    ctx.lineTo(boxX, boxY + boxR);
    ctx.quadraticCurveTo(boxX, boxY, boxX + boxR, boxY);
    ctx.closePath();
    ctx.fill();

    // Code text
    ctx.fillStyle = '#1a1a1a';
    ctx.font = `bold ${scale * 6}px monospace`;
    ctx.fillText(code, cW / 2, boxY + boxH / 2 + scale * 2);

    // Website
    ctx.fillStyle = 'rgba(255,255,255,0.6)';
    ctx.font = `${scale * 3}px Arial, Helvetica, sans-serif`;
    ctx.fillText(window.location.host, cW / 2, cH - scale * 6);

    // Add canvas to PDF
    const imgData = canvas.toDataURL('image/jpeg', 0.92);
    pdf.addImage(imgData, 'JPEG', 0, 0, pageW, pageH);
  }

  pdf.save(`flyers_${selectedCodes.length}_codes.pdf`);
}

// ===== PROMO CODES (with prefix) =====
function PromoTab() {
  const [excursions, setExcursions] = useState([]);
  const [codes, setCodes] = useState([]);
  const [selectedExc, setSelectedExc] = useState('');
  const [count, setCount] = useState(10);
  const [prefix, setPrefix] = useState('');
  const [generating, setGenerating] = useState(false);
  const [checked, setChecked] = useState({});
  const [pdfLoading, setPdfLoading] = useState(false);

  const load = useCallback(async () => {
    try { setExcursions(await adminGetExcursions()); setCodes(await adminGetPromoCodes()); } catch (e) { console.error(e); }
  }, []);
  useEffect(() => { load(); }, [load]);

  async function generate() {
    if (!selectedExc) return alert('Выберите экскурсию');
    setGenerating(true);
    try { await adminGeneratePromoCodes(parseInt(selectedExc), parseInt(count), prefix); load(); } catch (e) { alert(e.message); }
    setGenerating(false);
  }

  function copyUnused() {
    const unused = codes.filter(c => !c.is_used && (selectedExc ? c.excursion_id === parseInt(selectedExc) : true));
    navigator.clipboard.writeText(unused.map(c => c.code).join('\n')).then(() => alert(`Скопировано ${unused.length} кодов`));
  }

  function toggleCheck(id) { setChecked(prev => ({ ...prev, [id]: !prev[id] })); }
  function selectAllUnused() {
    const newChecked = {};
    filtered.forEach(c => { if (!c.is_used) newChecked[c.id] = true; });
    setChecked(newChecked);
  }
  function deselectAll() { setChecked({}); }

  const checkedCount = Object.values(checked).filter(Boolean).length;

  async function downloadPDF() {
    const selectedCodes = codes.filter(c => checked[c.id]).map(c => c.code);
    if (selectedCodes.length === 0) return alert('Выберите коды для скачивания');
    setPdfLoading(true);
    const excTitle = codes.find(c => checked[c.id])?.excursion_title || '';
    try { await generateFlyerPDF(selectedCodes, excTitle); } catch (e) { alert('Ошибка: ' + e.message); }
    setPdfLoading(false);
  }

  const filtered = selectedExc ? codes.filter(c => c.excursion_id === parseInt(selectedExc)) : codes;

  return (<div>
    <div className="admin-section-header"><h2>Промокоды (для партнёров)</h2></div>
    <div className="admin-form-card">
      <h3>Сгенерировать коды</h3>
      <div className="admin-row">
        <div className="admin-field" style={{flex: 1}}><label className="admin-label">Экскурсия</label>
          <select className="admin-input" value={selectedExc} onChange={e => setSelectedExc(e.target.value)}>
            <option value="">-- Все --</option>{excursions.map(exc => <option key={exc.id} value={exc.id}>{exc.title}</option>)}
          </select></div>
        <div className="admin-field" style={{flex: '0 0 80px'}}><label className="admin-label">Кол-во</label>
          <input className="admin-input" type="number" value={count} onChange={e => setCount(e.target.value)} min={1} max={100} /></div>
      </div>
      <div className="admin-field"><label className="admin-label">Префикс (для отслеживания партнёра)</label>
        <input className="admin-input" value={prefix} onChange={e => setPrefix(e.target.value)} placeholder="Например: HILTON, MARRIOTT, BOOKING" />
        <div style={{fontSize: 11, color: '#aaa', marginTop: 4}}>Код будет выглядеть: HILTON-A7X2K9M2</div>
      </div>
      <div className="admin-form-actions">
        <button className="admin-btn primary" onClick={generate} disabled={generating}>{generating ? 'Генерация...' : 'Сгенерировать'}</button>
        <button className="admin-btn" onClick={copyUnused}>Копировать неиспользованные</button>
      </div>
    </div>

    {/* PDF download controls */}
    {filtered.length > 0 && (
      <div className="admin-form-card" style={{ marginTop: 12 }}>
        <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', flexWrap: 'wrap', gap: 8 }}>
          <div style={{ display: 'flex', gap: 8 }}>
            <button className="admin-btn small" onClick={selectAllUnused}>Выбрать все активные</button>
            <button className="admin-btn small" onClick={deselectAll}>Снять выбор</button>
          </div>
          <div style={{ display: 'flex', gap: 8 }}>
            <button className="admin-btn primary small" onClick={downloadPDF} disabled={pdfLoading || checkedCount === 0}>
              {pdfLoading ? 'Генерация PDF...' : `Скачать PDF (${checkedCount})`}
            </button>
            <button className="admin-btn small danger" onClick={async () => {
              const ids = Object.entries(checked).filter(([_, v]) => v).map(([id]) => parseInt(id));
              if (ids.length === 0) return;
              if (!window.confirm(`Удалить ${ids.length} код(ов)?`)) return;
              try { await adminDeletePromoCodes(ids); setChecked({}); load(); } catch (e) { alert(e.message); }
            }} disabled={checkedCount === 0}>
              Удалить ({checkedCount})
            </button>
          </div>
        </div>
      </div>
    )}

    <div className="admin-promo-list">
      <div className="admin-promo-header"><span style={{width: 30}}></span><span>Код</span><span>Экскурсия</span><span>Статус</span></div>
      {filtered.map(c => (<div key={c.id} className={`admin-promo-item ${c.is_used ? 'used' : ''}`} style={{ cursor: 'pointer' }} onClick={() => !c.is_used && toggleCheck(c.id)}>
        <span style={{width: 30, flexShrink: 0}}>
          {!c.is_used && <input type="checkbox" checked={!!checked[c.id]} onChange={() => toggleCheck(c.id)} style={{ width: 16, height: 16 }} />}
        </span>
        <span className="admin-promo-code">{c.code}</span>
        <span className="admin-promo-exc">{c.excursion_title}</span>
        <span className={`admin-promo-status ${c.is_used ? 'used' : 'active'}`}>{c.is_used ? `Использован (${c.used_by_email})` : 'Активен'}</span>
      </div>))}
      {filtered.length === 0 && <p className="admin-empty">Нет промокодов</p>}
    </div>
  </div>);
}

// ===== DISCOUNT CODES (bloggers) =====
function DiscountsTab() {
  const [excursions, setExcursions] = useState([]);
  const [discounts, setDiscounts] = useState([]);
  const [form, setForm] = useState({ code_word: '', excursion_id: '', discount_percent: 10 });

  const load = useCallback(async () => {
    try { setExcursions(await adminGetExcursions()); setDiscounts(await adminGetDiscountCodes()); } catch (e) { console.error(e); }
  }, []);
  useEffect(() => { load(); }, [load]);

  async function create() {
    if (!form.code_word.trim()) return alert('Введите кодовое слово');
    if (!form.excursion_id) return alert('Выберите экскурсию');
    try { await adminCreateDiscountCode(form); setForm({ code_word: '', excursion_id: form.excursion_id, discount_percent: 10 }); load(); }
    catch (e) { alert(e.message); }
  }

  async function remove(id) {
    if (!window.confirm('Удалить скидочный код?')) return;
    try { await adminDeleteDiscountCode(id); load(); } catch (e) { alert(e.message); }
  }

  return (<div>
    <div className="admin-section-header"><h2>Скидочные коды (блогеры)</h2></div>
    <div className="admin-form-card">
      <h3>Создать кодовое слово</h3>
      <div className="admin-field"><label className="admin-label">Кодовое слово (например, имя блогера)</label>
        <input className="admin-input" value={form.code_word} onChange={e => setForm({...form, code_word: e.target.value})} placeholder="julia" /></div>
      <div className="admin-row">
        <div className="admin-field" style={{flex: 1}}><label className="admin-label">Экскурсия</label>
          <select className="admin-input" value={form.excursion_id} onChange={e => setForm({...form, excursion_id: parseInt(e.target.value)})}>
            <option value="">Выберите</option>{excursions.map(exc => <option key={exc.id} value={exc.id}>{exc.title}</option>)}
          </select></div>
        <div className="admin-field" style={{flex: '0 0 120px'}}><label className="admin-label">Скидка %</label>
          <input className="admin-input" type="number" value={form.discount_percent} onChange={e => setForm({...form, discount_percent: parseInt(e.target.value)})} min={1} max={100} /></div>
      </div>
      <div style={{fontSize: 12, color: '#888', marginBottom: 12}}>Пользователь введёт «{form.code_word || 'julia'}» и получит скидку {form.discount_percent}%</div>
      <button className="admin-btn primary" onClick={create}>Создать</button>
    </div>

    <div className="admin-list">
      {discounts.map(d => (<div key={d.id} className="admin-list-item">
        <div style={{ width: 40, height: 40, borderRadius: 10, background: '#e0f0ff', display: 'flex', alignItems: 'center', justifyContent: 'center', fontSize: 16, fontWeight: 800, color: '#4A90D9', flexShrink: 0 }}>%</div>
        <div className="admin-list-info">
          <strong>«{d.code_word}» — скидка {d.discount_percent}%</strong>
          <span className="admin-list-sub">{d.excursion_title} · Использований: {d.uses_count}</span>
        </div>
        <div className="admin-list-actions"><button className="admin-btn small danger" onClick={() => remove(d.id)}>Уд.</button></div>
      </div>))}
      {discounts.length === 0 && <p className="admin-empty">Нет скидочных кодов</p>}
    </div>
  </div>);
}

// --- Users Tab ---
function ExportUsersBlock() {
  const [from, setFrom] = useState('');
  const [to, setTo] = useState('');
  const [busy, setBusy] = useState(false);
  async function doExport() {
    setBusy(true);
    try { await adminExportUsers(from, to); }
    catch (e) { alert('Ошибка: ' + e.message); }
    setBusy(false);
  }
  return (
    <div style={{background: '#eef9f1', border: '1.5px solid #b6e0c2', borderRadius: 12, padding: 12, marginBottom: 12}}>
      <div style={{fontWeight: 700, marginBottom: 6}}>📥 Выгрузить пользователей в Excel</div>
      <div style={{fontSize: 12, color: '#666', marginBottom: 10}}>Выберите даты — выгрузятся регистрации за период. Если оставить пусто — выгрузятся все.</div>
      <div style={{display: 'flex', gap: 8, flexWrap: 'wrap', alignItems: 'flex-end'}}>
        <div style={{flex: '1 1 130px'}}>
          <label className="admin-label" style={{fontSize: 11}}>С даты</label>
          <input className="admin-input" type="date" value={from} onChange={e => setFrom(e.target.value)} />
        </div>
        <div style={{flex: '1 1 130px'}}>
          <label className="admin-label" style={{fontSize: 11}}>По дату (включительно)</label>
          <input className="admin-input" type="date" value={to} onChange={e => setTo(e.target.value)} />
        </div>
        <button className="admin-btn primary" onClick={doExport} disabled={busy}>
          {busy ? 'Готовим...' : 'Скачать CSV'}
        </button>
      </div>
      <div style={{fontSize: 11, color: '#888', marginTop: 8}}>Файл открывается в Excel. Колонки: Имя · Email · Телефон · Город · Дата регистрации.</div>
    </div>
  );
}

function UsersTab() {
  const [users, setUsers] = useState([]);
  const [loading, setLoading] = useState(true);
  const [search, setSearch] = useState('');
  const [selectedUser, setSelectedUser] = useState(null);
  const [detail, setDetail] = useState(null);
  const [detailLoading, setDetailLoading] = useState(false);
  const [mode, setMode] = useState('users'); // 'users' | 'exc'
  const [excList, setExcList] = useState([]);
  const [excSearch, setExcSearch] = useState('');
  const [excId, setExcId] = useState(null);
  const [players, setPlayers] = useState([]);
  const [playersLoading, setPlayersLoading] = useState(false);
  const [pSort, setPSort] = useState('activity'); // activity | name | done

  useEffect(() => {
    adminGetUsers().then(d => { setUsers(d); setLoading(false); }).catch(e => { console.error(e); setLoading(false); });
    adminGetExcursions().then(setExcList).catch(e => console.error(e));
  }, []);

  async function openExcursion(ex) {
    setExcId(ex.id);
    setPlayersLoading(true);
    try { setPlayers(await adminGetExcursionPlayers(ex.id)); }
    catch (e) { alert('Ошибка: ' + e.message); }
    setPlayersLoading(false);
  }

  function fmt(d) {
    if (!d) return '—';
    const dt = new Date(d);
    return dt.toLocaleDateString('ru', { day: '2-digit', month: '2-digit', year: '2-digit' }) + ' ' + dt.toLocaleTimeString('ru', { hour: '2-digit', minute: '2-digit' });
  }

  async function openUser(u) {
    setSelectedUser(u);
    setDetailLoading(true);
    try { const d = await adminGetUserDetail(u.id); setDetail(d); }
    catch (e) { alert('Ошибка: ' + e.message); }
    setDetailLoading(false);
  }

  function closeDetail() { setSelectedUser(null); setDetail(null); }

  async function delAnswers(excId, attemptId) {
    if (!window.confirm('Удалить ответы этого прохождения? Прогресс по экскурсии останется на месте.')) return;
    try {
      await adminDeleteUserAnswers(selectedUser.id, parseInt(excId), attemptId);
      const d = await adminGetUserDetail(selectedUser.id);
      setDetail(d);
    } catch (e) { alert('Ошибка: ' + e.message); }
  }

  async function delUserExcursion(excId, title) {
    if (!window.confirm(`Полностью удалить у пользователя экскурсию «${title || ''}»?\n\nБудут удалены: прохождение, покупка, все ответы и платежи по ней. Действие необратимо.`)) return;
    try {
      await adminDeleteUserExcursion(selectedUser.id, parseInt(excId));
      const d = await adminGetUserDetail(selectedUser.id);
      setDetail(d);
    } catch (e) { alert('Ошибка: ' + e.message); }
  }

  async function delThisUser() {
    if (!selectedUser) return;
    if (!window.confirm(`Удалить пользователя «${selectedUser.name}» (${selectedUser.email}) ПОЛНОСТЬЮ?\n\nБудут удалены: его аккаунт, все прохождения, ответы, покупки и платежи. Действие необратимо.`)) return;
    if (!window.confirm('Точно? Это окончательное удаление, без восстановления.')) return;
    try {
      await adminDeleteUser(selectedUser.id);
      closeDetail();
      const fresh = await adminGetUsers();
      setUsers(fresh);
    } catch (e) { alert('Ошибка: ' + e.message); }
  }

  const filtered = users.filter(u =>
    !search ||
    (u.name || '').toLowerCase().includes(search.toLowerCase()) ||
    (u.email || '').toLowerCase().includes(search.toLowerCase())
  );

  const sortedPlayers = [...players].sort((a, b) => {
    if (pSort === 'name') return (a.name || '').localeCompare(b.name || '');
    if (pSort === 'done') return (b.is_completed ? 1 : 0) - (a.is_completed ? 1 : 0);
    const ta = new Date(a.last_answer_at || a.progress_at || 0).getTime();
    const tb = new Date(b.last_answer_at || b.progress_at || 0).getTime();
    return tb - ta;
  });
  const curExc = excList.find(e => e.id === excId);

  if (loading) return <p className="admin-empty">Загрузка...</p>;

  return (<div>
    <div className="admin-section-header">
      <h2>{mode === 'users' ? `Пользователи (${users.length})` : 'Поиск по экскурсиям'}</h2>
    </div>

    <div style={{display: 'flex', gap: 8, marginBottom: 12}}>
      <button className={`admin-btn ${mode === 'users' ? 'primary' : ''}`} onClick={() => setMode('users')}>По пользователям</button>
      <button className={`admin-btn ${mode === 'exc' ? 'primary' : ''}`} onClick={() => setMode('exc')}>По экскурсиям</button>
    </div>

    {mode === 'users' ? (<>
      <ExportUsersBlock />
      <input className="admin-input" style={{marginBottom: 12}} placeholder="Поиск по имени или email..."
        value={search} onChange={e => setSearch(e.target.value)} />
      <div className="admin-list">
        {filtered.map(u => (
          <div key={u.id} className="admin-list-item" style={{cursor: 'pointer'}} onClick={() => openUser(u)}>
            <div className="admin-list-info">
              <strong>{u.name} {u.email_verified && <span style={{color: '#28a745', fontSize: 12, fontWeight: 'normal'}}>✓</span>}</strong>
              <span className="admin-list-sub">{u.email} · регистрация {fmt(u.created_at)}</span>
              <div style={{fontSize: 12, color: '#666', marginTop: 4}}>
                🎧 {u.excursions_started || 0} начато ·
                ✅ {u.excursions_completed || 0} пройдено ·
                💳 {u.excursions_purchased || 0} куплено
                {u.last_activity && <> · последняя активность: {fmt(u.last_activity)}</>}
              </div>
            </div>
          </div>
        ))}
        {filtered.length === 0 && <p className="admin-empty">{users.length === 0 ? 'Нет пользователей' : 'Ничего не найдено'}</p>}
      </div>
    </>) : !excId ? (<>
      <input className="admin-input" style={{marginBottom: 12}} placeholder="Поиск экскурсии/квеста по названию..."
        value={excSearch} onChange={e => setExcSearch(e.target.value)} />
      <div className="admin-list">
        {excList.filter(x => !excSearch || (x.title || '').toLowerCase().includes(excSearch.toLowerCase())).map(x => (
          <div key={x.id} className="admin-list-item" style={{cursor: 'pointer'}} onClick={() => openExcursion(x)}>
            <div className="admin-list-info">
              <strong>{x.title}</strong>
              <span className="admin-list-sub">{x.city_name || ''}{x.is_hidden ? ' · скрытая' : ''}</span>
            </div>
          </div>
        ))}
        {excList.length === 0 && <p className="admin-empty">Нет экскурсий</p>}
      </div>
    </>) : (<>
      <div style={{display: 'flex', alignItems: 'center', gap: 8, marginBottom: 10, flexWrap: 'wrap'}}>
        <button className="admin-btn" onClick={() => { setExcId(null); setPlayers([]); }}>← К списку экскурсий</button>
        <select className="admin-input" style={{width: 'auto'}} value={pSort} onChange={e => setPSort(e.target.value)}>
          <option value="activity">Сначала недавние</option>
          <option value="name">По имени</option>
          <option value="done">Сначала пройденные</option>
        </select>
      </div>
      <div style={{fontWeight: 700, marginBottom: 8}}>{curExc ? curExc.title : 'Экскурсия'} — игроков: {players.length}</div>
      {playersLoading ? <p className="admin-empty">Загрузка...</p> : (
        <div className="admin-list">
          {sortedPlayers.map(p => (
            <div key={p.id} className="admin-list-item" style={{cursor: 'pointer'}} onClick={() => openUser(p)}>
              <div className="admin-list-info">
                <strong>{p.name}</strong>
                <span className="admin-list-sub">{p.email}</span>
                <div style={{fontSize: 12, color: '#666', marginTop: 4}}>
                  {p.is_completed ? '✅ пройдено' : (p.current_step != null ? `🎧 шаг ${p.current_step}` : '— не начато')}
                  {' · '}🔁 прохождений: {p.attempts || 0}
                  {' · '}✍️ ответов: {p.answers_count || 0}
                  {p.last_answer_at && <> · посл. ответ: {fmt(p.last_answer_at)}</>}
                </div>
              </div>
            </div>
          ))}
          {players.length === 0 && <p className="admin-empty">Эту экскурсию ещё никто не проходил</p>}
        </div>
      )}
    </>)}

    {selectedUser && (
      <div style={{position: 'fixed', inset: 0, background: 'rgba(0,0,0,0.5)', zIndex: 100, display: 'flex', alignItems: 'flex-start', justifyContent: 'center', padding: 16, overflowY: 'auto'}}>
        <div style={{background: '#fff', borderRadius: 16, padding: 20, maxWidth: 600, width: '100%', marginTop: 20}}>
          <div style={{display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 12, gap: 8}}>
            <h3 style={{margin: 0, fontSize: 18, flex: 1, minWidth: 0, overflow: 'hidden', textOverflow: 'ellipsis'}}>{selectedUser.name}</h3>
            <button className="admin-btn small danger" onClick={delThisUser}>❌ Удалить пользователя</button>
            <button className="admin-btn" onClick={closeDetail}>Закрыть</button>
          </div>
          <p style={{color: '#666', fontSize: 13, marginBottom: 16}}>{selectedUser.email} · регистрация {fmt(selectedUser.created_at)}</p>

          {detailLoading ? <p className="admin-empty">Загрузка...</p> : detail && (
            <>
              <h4 style={{fontSize: 14, marginBottom: 8, color: '#333'}}>Прогресс по экскурсиям ({detail.progress.length})</h4>
              {detail.progress.length === 0 && <p style={{color: '#aaa', fontSize: 13, marginBottom: 12}}>Нет начатых экскурсий</p>}
              {detail.progress.map(p => (
                <div key={p.excursion_id} style={{background: '#f8f9fa', borderRadius: 10, padding: 12, marginBottom: 8}}>
                  <div style={{display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start', gap: 8}}>
                    <div style={{fontWeight: 600, fontSize: 14, flex: 1}}>{p.title}</div>
                    <button className="admin-btn small danger" onClick={() => delUserExcursion(p.excursion_id, p.title)}>🗑️ Сбросить</button>
                  </div>
                  <div style={{fontSize: 12, color: '#666', marginTop: 2}}>📍 {p.city_name || '—'}</div>
                  <div style={{display: 'flex', gap: 12, marginTop: 6, fontSize: 13, flexWrap: 'wrap'}}>
                    {p.is_completed ? (
                      <span style={{color: '#28a745', fontWeight: 600}}>✅ Пройдено</span>
                    ) : (
                      <span style={{color: '#3A7BD5'}}>🎧 Шаг {p.current_step} из {p.total_steps || '?'}</span>
                    )}
                    <span style={{color: '#888'}}>· {p.is_free ? 'Бесплатно' : `${p.price} ₽`}</span>
                    {p.purchase_type && <span style={{color: '#888'}}>· {p.purchase_type === 'promo_code' ? `код ${p.promo_code}` : p.purchase_type === 'discount' ? 'со скидкой' : 'оплата'}</span>}
                  </div>
                  <div style={{fontSize: 11, color: '#aaa', marginTop: 4}}>обновлено: {fmt(p.updated_at)}</div>
                </div>
              ))}

              {detail.purchases_only && detail.purchases_only.length > 0 && (
                <>
                  <h4 style={{fontSize: 14, margin: '16px 0 8px', color: '#333'}}>Куплено, но не начато ({detail.purchases_only.length})</h4>
                  {detail.purchases_only.map(p => (
                    <div key={p.excursion_id} style={{background: '#fff8e1', borderRadius: 10, padding: 12, marginBottom: 8}}>
                      <div style={{display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start', gap: 8}}>
                        <div style={{fontWeight: 600, fontSize: 14, flex: 1}}>{p.title}</div>
                        <button className="admin-btn small danger" onClick={() => delUserExcursion(p.excursion_id, p.title)}>🗑️ Сбросить</button>
                      </div>
                      <div style={{fontSize: 12, color: '#666'}}>📍 {p.city_name || '—'} · куплено {fmt(p.purchased_at)}</div>
                    </div>
                  ))}
                </>
              )}

              {detail.answers && detail.answers.length > 0 && (() => {
                const byExc = {};
                detail.answers.forEach(a => {
                  const ek = a.excursion_id;
                  if (!byExc[ek]) byExc[ek] = { title: a.excursion_title || `Экскурсия #${ek}`, attempts: {} };
                  const ak = a.attempt_id || '';
                  if (!byExc[ek].attempts[ak]) byExc[ek].attempts[ak] = [];
                  byExc[ek].attempts[ak].push(a);
                });
                return (
                  <>
                    <h4 style={{fontSize: 14, margin: '16px 0 8px', color: '#333'}}>Ответы на вопросы</h4>
                    {Object.entries(byExc).map(([excId, grp]) => {
                      const attemptList = Object.entries(grp.attempts)
                        .sort((x, y) => new Date(x[1][0].created_at) - new Date(y[1][0].created_at));
                      return (
                        <div key={excId} style={{marginBottom: 14}}>
                          <div style={{fontWeight: 700, fontSize: 14, marginBottom: 6}}>{grp.title}</div>
                          {attemptList.map(([ak, items], ai) => {
                            const correctCount = items.filter(it => it.is_correct).length;
                            return (
                              <div key={ak || 'none'} style={{border: '1px solid #eee', borderRadius: 10, padding: 12, marginBottom: 8}}>
                                <div style={{display: 'flex', justifyContent: 'space-between', alignItems: 'center', gap: 8, marginBottom: 8}}>
                                  <div style={{fontSize: 12, color: '#666'}}>
                                    {attemptList.length > 1 ? `Прохождение #${ai + 1}` : 'Прохождение'} · {fmt(items[0].created_at)} · верных {correctCount} из {items.length}
                                  </div>
                                  <button className="admin-btn small danger" onClick={() => delAnswers(excId, ak)}>Удалить</button>
                                </div>
                                {items.map((a, i) => (
                                  <div key={i} style={{padding: '6px 0', borderTop: i > 0 ? '1px solid #f0f0f0' : 'none'}}>
                                    <div style={{fontSize: 12, color: '#888'}}>Шаг {a.step_number} · {fmt(a.created_at)}</div>
                                    {a.question && <div style={{fontSize: 13, color: '#555', margin: '2px 0'}}>❓ {a.question}</div>}
                                    <div style={{fontSize: 14}}>
                                      {a.is_correct
                                        ? <span style={{color: '#28a745', fontWeight: 600}}>✅ «{a.answer_given}»</span>
                                        : <span style={{color: '#FF3B30', fontWeight: 600}}>❌ «{a.answer_given}»</span>}
                                      {a.used_hint && <span style={{fontSize: 11, color: '#f5a623', marginLeft: 8}}>💡 с подсказкой</span>}
                                    </div>
                                  </div>
                                ))}
                              </div>
                            );
                          })}
                        </div>
                      );
                    })}
                  </>
                );
              })()}
            </>
          )}
        </div>
      </div>
    )}
  </div>);
}

// ===== LANGUAGES =====
function LanguagesTab() {
  const [list, setList] = useState([]);
  const [form, setForm] = useState({ code: '', name: '', native_name: '', is_rtl: false });
  const load = useCallback(async () => { try { setList(await adminGetLanguages()); } catch (e) { alert(e.message); } }, []);
  useEffect(() => { load(); }, [load]);

  async function add() {
    try { await adminCreateLanguage(form); setForm({ code: '', name: '', native_name: '', is_rtl: false }); load(); } catch (e) { alert(e.message); }
  }
  async function toggle(l, key) {
    try { await adminUpdateLanguage(l.code, { ...l, [key]: !l[key] }); load(); } catch (e) { alert(e.message); }
  }
  async function remove(l) {
    if (!window.confirm('Убрать язык «' + l.name + '»? Уже сделанные переводы не удалятся, просто перестанут показываться.')) return;
    try { await adminDeleteLanguage(l.code); load(); } catch (e) { alert(e.message); }
  }

  return (<div>
    <div className="admin-section-header"><h2>Языки</h2></div>
    <p style={{fontSize: 13, color: '#666', marginTop: 0}}>
      Основной язык заполняется всегда. Для остальных языков в формах экскурсий и шагов появляются вкладки:
      там можно перевести тексты и загрузить своё аудио. Что не переведено, игрок увидит на основном языке.
      «Скрыть» убирает язык из переключателя у игроков, но переводы сохраняются.
    </p>
    <div className="admin-list">
      {list.map(l => (<div key={l.code} className="admin-list-item">
        <div className="admin-step-num" style={{width: 'auto', padding: '0 10px'}}>{l.code.toUpperCase()}</div>
        <div className="admin-list-info">
          <strong>{l.name} <span dir="auto" style={{fontWeight: 'normal', color: '#888'}}>{l.native_name}</span></strong>
          <span className="admin-list-sub">
            {l.is_default ? 'Основной язык' : (l.is_active ? 'Показывается игрокам' : 'Скрыт от игроков')}
            {l.is_rtl ? ' · письмо справа налево' : ''}
          </span>
        </div>
        {!l.is_default && (<div className="admin-list-actions">
          <button className="admin-btn small" onClick={() => toggle(l, 'is_active')}>{l.is_active ? 'Скрыть' : 'Показать'}</button>
          <button className="admin-btn small danger" onClick={() => remove(l)}>Уд.</button>
        </div>)}
      </div>))}
    </div>
    <div className="admin-form-card" style={{marginTop: 16}}>
      <h3>Добавить язык</h3>
      <div className="admin-row">
        <div className="admin-field" style={{flex: '0 0 110px'}}><label className="admin-label">Код</label><input className="admin-input" placeholder="fr" value={form.code} onChange={e => setForm({...form, code: e.target.value.toLowerCase()})} /></div>
        <div className="admin-field" style={{flex: 1}}><label className="admin-label">Название (по-русски)</label><input className="admin-input" placeholder="Французский" value={form.name} onChange={e => setForm({...form, name: e.target.value})} /></div>
        <div className="admin-field" style={{flex: 1}}><label className="admin-label">Как пишется на самом языке</label><input className="admin-input" dir="auto" placeholder="Français" value={form.native_name} onChange={e => setForm({...form, native_name: e.target.value})} /></div>
      </div>
      <div className="admin-field"><label className="admin-label"><input type="checkbox" checked={form.is_rtl} onChange={e => setForm({...form, is_rtl: e.target.checked})} /> Письмо справа налево (арабский, иврит, фарси)</label></div>
      <div style={{fontSize: 11, color: '#888', marginBottom: 10}}>Код — две латинские буквы: en английский, ar арабский, ru русский, fr французский, de немецкий, zh китайский, hi хинди, es испанский.</div>
      <div className="admin-form-actions"><button className="admin-btn primary" onClick={add} disabled={!form.code || !form.name}>Добавить</button></div>
    </div>
  </div>);
}
